/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($, _c, undefined) {
  'use strict';

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.

  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages
        /*$(function(){
                  if ($('#myCounter')) {
                      var dataN = parseInt($('#myCounter').attr('data-value'));
                      var newDataN = parseInt($('#myCounter').attr('data'));

                      var myCounter = new flipCounter('myCounter', {value: dataN, inc: 1, pace: 1000, auto: true});
                      setTimeout(function(){
                          $('#myCounter').remove();
                          var myCounter = new flipCounter('myCounterNew', {value: newDataN, inc: 1, pace: 7200, auto: true});
                          $('#myCounterNew').show();
                      }, 1100);
                  }
              });*/

        function initVideoPlay() {
          var YTAPIScript = document.createElement('script');
          YTAPIScript.src = '//www.youtube.com/iframe_api';
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(YTAPIScript, firstScriptTag);
          var videoPlayClass = 'video-playing';
          var players = [];

          window.onYouTubeIframeAPIReady = function () {
            players.forEach(function (player) {
              player.instance = new YT.Player(player.domNode, {
                height: '100%',
                width: '100%',
                videoId: player.youtubeVideoId,  // youtube video id
                playerVars: {
                  'autoplay': 0,
                  'rel': 0,
                  'showinfo': 0,
                },
                events: {
                  'onStateChange': onPlayerStateChange,
                },
              });
            });
          };
          window.onPlayerStateChange = function (event) {
            players.forEach(function (player) {
              if (event.data == YT.PlayerState.PLAYING && !player.done) {
                player.btnPlay.fadeIn('normal');
              }
            });
          };
          jQuery('.youtube-video-block').each(function () {
            var container = jQuery(this);
            var frame = container.find('iframe');
            var btnPlay = container.find('.play-btn');
            var src = frame.attr('src') || frame.attr('data-src');
            if (!src) {
              return;
            }
            var done = false;
            var youtubeVideoId = src.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/);
            youtubeVideoId = youtubeVideoId.pop();
            var replaced = $('<div/>');
            frame.replaceWith(replaced);

            var player = {
              youtubeVideoId: youtubeVideoId,
              instance: null,
              btnPlay: btnPlay,
              domNode: replaced[0],
              done: done,
            };
            players.push(player);

            btnPlay.on('click', function (e) {
              e.preventDefault();
              player.instance.playVideo();
              container.addClass(videoPlayClass);
            });

          });

          jQuery('.vimeo-video-block').each(function () {
            var container = jQuery(this);
            var frame = container.find('iframe');
            var btnPlay = container.find('.play-btn');
            var src = frame.attr('src') || frame.attr('data-src');
        
            if (!src) {
                return;
            }
        
            var vimeoVideoMatch = src.match(/vimeo\.com\/video\/(\d+)(\?.*)?/);
            if (!vimeoVideoMatch || vimeoVideoMatch.length < 2) {
                console.warn('Invalid Vimeo video URL:', src);
                return;
            }
        
            var videoId = vimeoVideoMatch[1];
            var queryParams = vimeoVideoMatch[2] || '';
        
            var replaced = $('<div/>');
            frame.replaceWith(replaced);
        
            var player = new Vimeo.Player(replaced[0], {
                url: `https://player.vimeo.com/video/${videoId}${queryParams}`,
                width: 640
            });
        
            btnPlay.on('click', function (e) {
                e.preventDefault();
                player.play().then(function () {
                    container.addClass('video-playing');
                }).catch(function (error) {
                    console.error('Error playing video:', error);
                });
            });
          });

          jQuery('.html5-video-block').each(function () {
            var container = jQuery(this);
            var playButton = container.find('.html5-play-btn');

            // Event listener for the play/pause button
            container.on('click', playButton, function (e) {
              container.find('video').get(0).play();
              container.addClass(videoPlayClass);
            });
          });
        }

        initVideoPlay();

        $('body').on('click', '.play-button', function () {
          if ($(this).hasClass('paused')) {
            $(this).removeClass('paused');
            $('#hero .video-wrapper #banner-video').get(0).play();
            $('#banner-video-1').get(0).play();
          } else {
            $(this).addClass('paused');
            $('#hero .video-wrapper #banner-video').get(0).pause();
            $('#banner-video-1').get(0).pause();
          }
          return false;
        });

        const $announcementBanner = $('body > .announcement-banner');
        const ANNOUNCEMENT_BANNER_FLAG_NAME = 'announcementBannerState';
        if ($announcementBanner.length) {
          if (sessionStorage.getItem(ANNOUNCEMENT_BANNER_FLAG_NAME) == 'hidden') {
            $(document.body).removeClass('show-banner');
          }
          $announcementBanner.on('click', '.close', function () {
            sessionStorage.setItem(ANNOUNCEMENT_BANNER_FLAG_NAME, 'hidden');
            $(document.body).removeClass('show-banner');
          });
        }

        const $pageBanner = $('.page-banner');
        const PAGE_BANNER_FLAG_NAME = 'pageBannerState';
        if ($pageBanner.length) {
          if (sessionStorage.getItem(PAGE_BANNER_FLAG_NAME) === 'hidden') {
            $(document.body).removeClass('show-banner');
            document.querySelector('.page-banner').remove();
          }
          $pageBanner.on('click', '.close', function () {
            sessionStorage.setItem(PAGE_BANNER_FLAG_NAME, 'hidden');
            $(document.body).removeClass('show-banner');
            document.querySelector('.page-banner').remove();
          });
        }

        $('.scrollto').on('click', function (event) {
          event.preventDefault();
          var section = $(this).attr('href');
          $('html, body').animate(
            {
              scrollTop: $(section).offset().top,
            },
            1000,
          );
        });

        if ($('.reveal, .vert-reveal, .left-reveal, .laptop-reveal, .center-reveal').length > 0) {
          $(
            '.reveal, .vert-reveal, .left-reveal, .laptop-reveal, .center-reveal',
          ).each(function (e) {
            var reveal = $(this);
            var waypoint_reveal = new Waypoint({
              element: reveal[0],
              handler: function (direction) {
                if (direction === 'down') {
                  reveal.addClass('on');
                }
              },
              offset: '100%',
            });
          });
        }

        // START Lightbox for component-video-section
        $('.lightbox-video-section').each(function () {
          var video = $(this).find('video').get(0);
          if (video) {
            video.pause();
            $('.lightbox-video-section').find('video').get(0).pause();
          }
        });

        jQuery('.video-section-component').each(function () {
          var $section = $(this);
      
          $section.find('.open-video-lightbox').off('click').on('click', function(ev) {
              var team = $(this).attr('href');
              $(team).fadeIn(0);
              $('body').addClass('open-lightbox full-video-section-lightbox');
      
              if ($(team).find('video').length) {
                  $(team).find('video').get(0).play();
              }
      
              var $iframe = $(team).find("iframe");
      
              if ($iframe.length) {
                  var src = $iframe.attr("src");
      
                  if (!$iframe.data("src")) {
                      $iframe.data("src", src);
                  }
      
                  if (!src.includes("?")) {
                      src += "?";
                  }

                  if (!src.includes("autoplay=1")) {
                      src += (src.endsWith("?") ? "" : "&") + "autoplay=1&mute=0";
                      $iframe.attr("src", src);
                  }
      
                  if (src.includes("youtube.com") || src.includes("youtu.be")) {
                      $iframe[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                  } else if (src.includes("vimeo.com")) {
                      $iframe[0].contentWindow.postMessage('{"method":"play"}', '*');
                  }
              }
      
              ev.preventDefault();
          });
      
          $section.find('.close-medium-lightbox').off('click').on('click', function(ev) {
              ev.preventDefault();
              $('body').removeClass('open-lightbox full-video-section-lightbox');
              $('.lightbox-video-section').fadeOut(0);
              $('.page-overlay').hide();
      
              var $iframe = $(this).closest('.lightbox-video-section').find("iframe");
      
              if ($iframe.length) {
                  var src = $iframe.attr("src");
      
                  if (src.includes("youtube.com") || src.includes("youtu.be")) {
                      $iframe[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                      $iframe.attr("src", "");
                      setTimeout(() => {
                          $iframe.attr("src", $iframe.data("src"));
                      }, 300);
                  } else if (src.includes("vimeo.com")) {
                      $iframe[0].contentWindow.postMessage('{"method":"pause"}', '*');
                  }
              }
      
              var video = $(this).closest('.lightbox-video-section').find('video').get(0);
              if (video) {
                  video.pause();
              }
          });
        });

        // END Lightbox for component-video-section

        if ($('.quote')) {
          $('.open-video').click(function () {
            var href = $(this).attr('href');
            event.preventDefault();
            $('+ href +').fadeIn(0);

          });
          $('.lightbox .close').on('click', function () {
            $('.lightbox').fadeOut(0);
            $('.page-overlay').hide();
            var vid = jQuery(this).closest('.lightbox').find('iframe[src*="youtube"]');
            if (vid.length > 0) {
              var src = vid.attr('src');
              vid.attr('src', '');
              vid.attr('src', src);
            }
          });
        }
        if ($('.faq-list').length) {
          $('.faq-list').each(function () {
            var $faq = $(this);
        
            $faq.find('.f-item h4').click(function () {
              var $parentItem = $(this).parent();
              var $container = $parentItem.closest('.faq-list');
        
              if ($parentItem.hasClass('active')) {
                $container.find('.f-item').removeClass('active');
                $container.find('.hide-text').slideUp();
              } else {
                $container.find('.f-item').removeClass('active');
                $container.find('.hide-text').slideUp();
                $parentItem.addClass('active');
                $parentItem.find('.hide-text').slideDown();
              }
              return false;
            });
          });
        }        

        function checkMedia() {
          var scrollTop = $(window).scrollTop() + tolerancePixel;
          var scrollBottom = $(window).scrollTop() + $(window).height() - tolerancePixel;

          media.each(function (index, el) {
            var yTopMedia = $(this).offset().top;
            var yBottomMedia = $(this).height() + yTopMedia;

            if (scrollTop < yBottomMedia && scrollBottom > yTopMedia) {
              $(this).get(0).play();
            }
          });
        }

        if ($('#scrolled-video')) {
          var media = $('#scrolled-video');
          var tolerancePixel = 40;

          $(document).on('scroll', checkMedia);
        }

        function debounce(func, wait, immediate) {
          var timeout;
          return function () {
            var context = this,
              args = arguments;
            var later = function () {
              timeout = null;
              if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
          };
        }

        function killTheMenu() {
          $('.nav').removeClass('open');
          $('.nav li').removeClass('show');
          $('header').removeClass('menu-open');
          $('.hamburger').removeClass('is-active');
        }

        $('html').click(function () {
          if ($('.nav').hasClass('open')) {
            killTheMenu();
          }
        });

        $('.nav').click(function (event) {
          event.stopPropagation();
        });

        var killMenuOnScroll = debounce(function () {
          var navHeight = $('.nav').outerHeight();
          if ($(document).scrollTop() >= navHeight) {
            killTheMenu();
          }
        }, 150);

        document.addEventListener('scroll', killMenuOnScroll);

        var lightboxes = jQuery('.video-carousel-component .video-cnt');

        lightboxes.each(function (_, lightbox) {
          var video = $(lightbox).find('iframe[src*="uploads"]');
          var src = video.attr('src');
          video.attr('src', '');

          $(lightbox).find('.open-video').click(function () {
            if (video.length > 0) {
              video.attr('src', src);
            }
          });

          $(lightbox).find('.lightbox .close').on('click', function () {
            $('.lightbox').fadeOut(0);
            $('.page-overlay').hide();
            if (video.length > 0) {
              video.attr('src', '');
            }
          });
        });

        if ($('.lightbox').length > 0) {
          $('.people-section .team-cnt .overlay .permalink, .stories-section .cnt .name-cnt a, .lab-section .gray-box .gene-popup').
            on('click', function (event) {
              event.preventDefault();
              var team = $(this).attr('href');
              $(team).fadeIn(0);
            });
          $('.lab-section .gray-box .gene-popup').on('click', function (event) {
            $('.page-overlay').fadeIn(0);
          });

          if ($('.jobs-section').length) {
            return false;
          } else {
            $('.job-list a').on('click', function (event) {
              event.preventDefault();
              var job = $(this).attr('href');
              $(job).fadeIn(0);
              return false;
            });
          }

          $('.open-video').on('click', function (event) {
            event.preventDefault();
            var team = $(this).attr('href');

            $(team).fadeIn(0);
            $('body').addClass('open-lightbox');

            if ($('#movie1').length) {
              $('#movie1').get(0).pause();
            }
            if ($('#movie2').length) {
              $('#movie2')[0].play();
            }
          });

          $('.lightbox .close-medium').on('click', function () {
            $('body').removeClass('open-lightbox');
            $('.lightbox').fadeOut(0);
            $('.page-overlay').hide();
            var vid = jQuery(this).closest('.lightbox').find('iframe[src*="youtube"]');
            if (vid.length > 0) {
              var src = vid.attr('src');
              vid.attr('src', '');
              vid.attr('src', src);
            }

            if ($('#movie2').length) {
              $('#movie2').get(0).pause();
            }
            if ($('#movie1').length) {
              $('#movie1')[0].play();
            }
          });

          $('.lightbox .close').on('click', function () {
            $('body').removeClass('open-lightbox');
            $('.lightbox').fadeOut(0);
            $('.page-overlay').hide();
            var vid = jQuery(this).closest('.lightbox').find('iframe[src*="youtube"]');
            if (vid.length > 0) {
              var src = vid.attr('src');
              vid.attr('src', '');
              vid.attr('src', src);
            }

            if ($('#movie2').length) {
              $('#movie2').get(0).pause();
            }
            if ($('#movie1').length) {
              $('#movie1')[0].play();
            }
          });

          $('.page-overlay').click(function (event) {
            $('.lightbox').fadeOut(0);
            $('.page-overlay').hide();
            event.stopPropagation();
          });

          $('.open-video-item').on('click', function (event) {
            event.preventDefault();
            var team = $(this).attr('href');
            $(team).fadeIn(0);
            $('body').addClass('open-lightbox');
            $('video').get(0).pause();
            $(team).find('video')[0].play();
          });
          $('.lightbox .close-item').on('click', function () {
            $('body').removeClass('open-lightbox');
            $('.lightbox').fadeOut(0);
            $('.page-overlay').hide();
            $(this).next().get(0).pause();
          });
        }

        var black_scroll_section_height = $(
          '.black-fixed-scroll-section .trigger',
        ).length;
        $('.black-fixed-scroll-section').css(
          'height',
          black_scroll_section_height + '00vh',
        );

        var scroll_section_height = $('.fixed-scroll-section .trigger').length;
        $('.fixed-scroll-section').css(
          'height',
          scroll_section_height + '00vh',
        );

        $('select').wrap('<div class="select-wrap"></div>');

        function fallback(video) {
          var img = video.querySelector('img');
          if (img) {
            video.parentNode.replaceChild(img, video);
          }
        }

        $(window).scroll(function () {
          var scroll = $(window).scrollTop();
          $('.diagonal-bg svg line').attr(
            'stroke-width',
            50 + scroll / 10 + '%',
          );
          $('.mobile-diagonal-bg svg line').attr(
            'stroke-width',
            50 + scroll / 10 + '%',
          );
          //30 is the starting width
          //alter the amount of growth by changing scroll/x
        });

        if ($('body').hasClass('single')) {
          $('.page-crumb').hide();
        }

        $('a.disable').on('click', function (e) {
          e.preventDefault();
        });

        //Parallax Image Scroll
        $(window).on('scroll', function () {
          if ($('.parallax-image').length > 0) {
            $('.parallax-image').each(function () {
              var image = $(this);
              var imageTop = image.offset().top;
              var scrollTop = $(window).scrollTop();
              var offsetScrollTop = scrollTop + $(window).height();
              var fullScroll = $(window).height() + image.height();
              if ((scrollTop + $(window).height()) >= imageTop && scrollTop < (image.height() + imageTop)) {
                var scrollPercent = ((offsetScrollTop - imageTop) / fullScroll) * 100;
                image.css('background-position', '50% ' + (100 - scrollPercent) + '%');
              }
            });
          }
        });

        $('.hamburger').on('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          $('.hamburger').toggleClass('is-active');
          $('.brand').toggleClass('active-navigation');
          if ($('.hamburger').hasClass('is-active')) {
            $('body').addClass('no-scroll');
            $('header .navigation-drop').addClass('open');
            navHeight();
          } else {
            $('header .navigation-drop').removeClass('open');
            setTimeout(function () {
              $('body').removeClass('no-scroll');
            }, 900);
          }
        });

        $(window).resize(function () {
          navHeight();
        });

        function navHeight() {
          if ($('.medium-nav').length) {
            var colh = 0;
            // var coln = 0;
            $('.nav-item .secondary-nav').each(function () {
              var h_colw = parseInt($(this).outerHeight());
              if (h_colw > colh) {
                colh = h_colw;
                // coln = colh + 10;
              }
            });
            $('.medium-nav .nav-item').css('height', colh);
          }
        }

        function stickyHeader() {
          if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            $('header').removeClass('page-top').addClass('color-top');
          } else {
            $('header').removeClass('color-top').addClass('page-top');
          }
        }

        document.addEventListener('scroll', stickyHeader);

        $('.tabs-title .tab a').on('click', function (evt) {
          evt.preventDefault();
          $('.tabs-title .tab').removeClass('active');
          $(this).parent().addClass('active');
          var sel = this.getAttribute('data-toggle-target');
          $('.tab-item').removeClass('active').filter(sel).addClass('active').fadeIn();
          ;
        });

        function _extends() {
          _extends = Object.assign ? Object.assign.bind() : function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i];
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; }
              }
            }
            return target;
          };
          return _extends.apply(this, arguments);
        }

        /*!
            * Custom Select jQuery Plugin
            */
        var CustomSelect = function ($) {
          var defaults = {
            block: 'custom-select',
            hideCallback: false,
            includeValue: false,
            keyboard: true,
            modifier: false,
            placeholder: false,
            search: false,
            showCallback: false,
            transition: 0,
          };

          var CustomSelect = /*#__PURE__*/function () {
            /**
             * Custom Select
             *
             * @param {Element} select Original `<select>` DOM element to customize.
             * @param {(Object|string)=} options Settings object or method name.
             * @param {string=} options.block Custom select BEM block name.
             * @param {Function=} options.hideCallback Fires after dropdown closes.
             * @param {boolean=} options.includeValue Adds chosen value option to
             *     dropdown. If enabled also cancels dropdown options rerender.
             * @param {boolean=} options.keyboard Enables keyboard control.
             * @param {string=} options.modifier Custom select block BEM modifier.
             * @param {string=} options.placeholder Placeholder hint, can be an HTML
             *     string (appears only if there is no explicitly selected options).
             * @param {boolean=} options.search Adds input to filter options.
             * @param {Function=} options.showCallback Fires after dropdown opens.
             * @param {(number|string)=} options.transition jQuery slideUp/Down param.
             */
            function CustomSelect(select, options) {
              this._$select = $(select);
              this._options = _extends({}, defaults, typeof options === 'object' ? options : {}); // Modifiers

              this._activeModifier = this._options.block + '--active';
              this._dropupModifier = this._options.block + '--dropup';
              this._optionSelectedModifier = this._options.block + '__option--selected'; // Event handlers that can be removed

              this._keydown = this._keydown.bind(this);
              this._dropup = this._dropup.bind(this);
              this._outside = this._outside.bind(this);

              this._init();
            }

            /**
             * Resets custom select options.
             *
             * @public
             */


            var _proto = CustomSelect.prototype;

            _proto.reset = function reset() {
              this._$dropdown.hide().empty();

              this._$value.off('click');

              this._fill();
            }
            /**
             * Renders initial state of custom select & sets
             * options click event listeners.
             *
             * @private
             */
            ;

            _proto._init = function _init() {
              this._$element = $(
                '<div class="' + this._options.block + '">\n           <button class="' + this._options.block +
                '__option ' + this._options.block +
                '__option--value" type="button"></button>\n           <div class="' + this._options.block +
                '__dropdown" style="display: none;"></div>\n         </div>');

              this._$select.hide().after(this._$element);

              if (this._options.modifier) {
                this._$element.addClass(this._options.modifier);
              }

              this._$value = this._$element.find('.' + this._options.block + '__option--value');
              this._$dropdown = this._$element.find('.' + this._options.block + '__dropdown');

              this._fill();
            }
            /**
             * Renders custom select options by original
             * select element options.
             *
             * @private
             */
            ;

            _proto._fill = function _fill() {
              var _this = this;

              this._$values = this._$select.find('option');
              this._values = [];
              var placeholder = this._options.placeholder;
              $.each(this._$values, function (i, option) {
                var el = $(option).text().trim();

                _this._values.push(el);
              });

              if (placeholder) {
                // Check explicitly selected option
                if (this._$select.find('[selected]').length) {
                  placeholder = false;
                } else {
                  this._$value.html(placeholder); // Set select value to null

                  this._$select.prop('selectedIndex', -1);
                }
              }

              $.each(this._values, function (i, el) {
                var cssClass = _this._$values.eq(i).attr('class');

                var $option = $(
                  '<button class="' + _this._options.block + '__option" type="button">' + el + '</button>');

                var $selected = _this._$select.find(':selected');

                if (_this._$values.eq(i).attr('disabled')) {
                  $option.prop('disabled', true);
                }

                if (!$selected.length && i === 0 || el === $selected.text().trim()) {
                  if (!placeholder) {
                    _this._$value.text(el).
                      removeClass(_this._$value.data('class')).
                      removeData('class').
                      addClass(cssClass).
                      data('class', cssClass);
                  }

                  if (_this._options.includeValue || placeholder) {
                    $option.addClass(cssClass);
                    $option.toggleClass(_this._optionSelectedModifier, _this._$values.eq(i).is('[selected]'));

                    _this._$dropdown.append($option);
                  }
                } else {
                  $option.addClass(cssClass);

                  _this._$dropdown.append($option);
                }
              });
              this._$options = this._$dropdown.find('.' + this._options.block + '__option');

              if (this._options.search) {
                this._search();
              }

              this._$value.one('click', function (event) {
                _this._show(event);
              });

              this._$value.prop('disabled', !this._$options.length);

              this._$options.on('click', function (event) {
                _this._select(event);
              });
            }
            /**
             * Shows custom select dropdown & sets outside
             * click listener to hide.
             *
             * @param {Object} event Value click jQuery event.
             * @private
             */
            ;

            _proto._show = function _show(event) {
              var _this2 = this;

              event.preventDefault();

              this._dropup();

              $(window).on('resize scroll', this._dropup);

              this._$element.addClass(this._activeModifier);

              this._$dropdown.slideDown(this._options.transition, function () {
                if (_this2._options.search) {
                  _this2._$input.focus();

                  if (_this2._options.includeValue) {
                    _this2._scroll();
                  }
                } // Open callback

                if (typeof _this2._options.showCallback === 'function') {
                  _this2._options.showCallback.call(_this2._$element[0]);
                }
              });

              setTimeout(function () {
                $(document).on('touchstart click', _this2._outside);
              }, 0);

              this._$value.one('click', function (event) {
                event.preventDefault();

                _this2._hide();
              });

              if (this._options.keyboard) {
                this._options.index = -1;
                $(window).on('keydown', this._keydown);
              }
            }
            /**
             * Hides custom select dropdown & resets events
             * listeners to initial.
             *
             * @private
             */
            ;

            _proto._hide = function _hide() {
              var _this3 = this;

              if (this._options.search) {
                this._$input.val('').blur();

                this._$options.show();

                this._$wrap.scrollTop(0);
              }

              this._$dropdown.slideUp(this._options.transition, function () {
                _this3._$element.removeClass(_this3._activeModifier).removeClass(_this3._dropupModifier); // Close callback

                if (typeof _this3._options.hideCallback === 'function') {
                  _this3._options.hideCallback.call(_this3._$element[0]);
                }

                _this3._$value.off('click').one('click', function (event) {
                  _this3._show(event);
                });

                $(document).off('touchstart click', _this3._outside);
                $(window).off('resize scroll', _this3._dropup);
              });

              if (this._options.keyboard) {
                this._$options.blur();

                $(window).off('keydown', this._keydown);
              }
            }
            /**
             * Centers chosen option in scrollable element
             * of dropdown.
             *
             * @private
             */
            ;

            _proto._scroll = function _scroll() {
              var _this4 = this;

              $.each(this._$options, function (i, option) {
                var $option = $(option);

                if ($option.text() === _this4._$value.text()) {
                  var top = $option.position().top;

                  var height = _this4._$wrap.outerHeight();

                  var center = height / 2 - $option.outerHeight() / 2;

                  if (top > center) {
                    _this4._$wrap.scrollTop(top - center);
                  }

                  return false;
                }
              });
            }
            /**
             * Changes value of custom select & `<select>`
             * by chosen option.
             *
             * @param {Object} event Option click jQuery event.
             * @private
             */
            ;

            _proto._select = function _select(event) {
              var _this5 = this;

              event.preventDefault();
              var choice = $(event.currentTarget).text().trim();
              var values = [].concat(this._values);

              this._$value.text(choice).removeClass(this._$value.data('class'));

              this._$values.prop('selected', false);

              $.each(values, function (i, el) {
                if (!_this5._options.includeValue && el === choice) {
                  values.splice(i, 1);
                }

                $.each(_this5._$values, function (i, option) {
                  var $option = $(option);

                  if ($option.text().trim() === choice) {
                    var cssClass = $option.attr('class');
                    $option.prop('selected', true);

                    _this5._$value.addClass(cssClass).data('class', cssClass);
                  }
                });
              });

              this._hide();

              if (!this._options.includeValue) {
                // Update dropdown options content
                if (this._$options.length > values.length) {
                  var last = this._$options.eq(values.length);

                  last.remove();
                  this._$options = this._$options.not(last);

                  if (!this._$options.length) {
                    this._$value.prop('disabled', true);
                  }
                }

                $.each(this._$options, function (i, option) {
                  var $option = $(option);
                  $option.text(values[i]); // Reset option class

                  $option.attr('class', _this5._options.block + '__option');
                  $.each(_this5._$values, function () {
                    var $this = $(this);

                    if ($this.text().trim() === values[i]) {
                      $option.addClass($this.attr('class'));
                      $option.prop('disabled', $this.prop('disabled'));
                    }
                  });
                });
              } else {
                // Select chosen option
                this._$options.removeClass(this._optionSelectedModifier);

                $.each(this._$options, function (i, option) {
                  var $option = $(option);

                  if ($option.text().trim() === choice) {
                    $option.addClass(_this5._optionSelectedModifier);
                    return false;
                  }
                });
              }

              if (typeof event.originalEvent !== 'undefined') {
                this._$select.trigger('change');
              }
            }
            /**
             * Wraps options by wrap element, adds search
             * input to dropdown.
             *
             * @private
             */
            ;

            _proto._search = function _search() {
              var _this6 = this;

              this._$input = $('<input class="' + this._options.block + '__input" autocomplete="off">');

              this._$dropdown.prepend(this._$input); // Add scrollable wrap

              this._$options.wrapAll('<div class="' + this._options.block + '__option-wrap"></div>');

              this._$wrap = this._$element.find('.' + this._options.block + '__option-wrap');

              this._$input.on('focus', function () {
                _this6._options.index = -1;
              });

              this._$input.on('keyup', function () {
                var query = _this6._$input.val().trim();

                if (query.length) {
                  _this6._$wrap.scrollTop(0);

                  setTimeout(function () {
                    if (query === _this6._$input.val().trim()) {
                      $.each(_this6._$options, function (i, option) {
                        var $option = $(option);
                        var text = $option.text().trim().toLowerCase();
                        var match = text.indexOf(query.toLowerCase()) !== -1;
                        $option.toggle(match);
                      });
                    }
                  }, 300);
                } else {
                  _this6._$options.show();
                }
              });
            }
            /**
             * Toggles custom select dropup modifier based
             * on space for dropdown below.
             *
             * @private
             */
            ;

            _proto._dropup = function _dropup() {
              var bottom = this._$element[0].getBoundingClientRect().bottom;

              var up = $(window).height() - bottom < this._$dropdown.height();

              this._$element.toggleClass(this._dropupModifier, up);
            }
            /**
             * Hides dropdown if target of event (e.g. click
             * on `$window`) is not custom select.
             *
             * @param {Object} event Outside "click" jQuery event.
             * @private
             */
            ;

            _proto._outside = function _outside(event) {
              var $target = $(event.target);

              if (!$target.parents().is(this._$element) && !$target.is(this._$element)) {
                this._hide();
              }
            }
            /**
             * Controls navigation from keyboard by custom
             * select options.
             *
             * @param {Object} event Keydown jQuery event.
             * @private
             */
            ;

            _proto._keydown = function _keydown(event) {
              var $visible = this._$options.filter(':visible').not('[disabled]');

              switch (event.which) {
                // Down
                case 40:
                  event.preventDefault();
                  var next = $visible.eq(this._options.index + 1).length;

                  if (next) {
                    this._options.index += 1;
                  } else {
                    this._options.index = 0;
                  }

                  $visible.eq(this._options.index).focus();
                  break;
                // Up

                case 38:
                  event.preventDefault();
                  var prev = $visible.eq(this._options.index - 1).length;

                  if (prev && this._options.index - 1 >= 0) {
                    this._options.index -= 1;
                  } else {
                    this._options.index = $visible.length - 1;
                  }

                  $visible.eq(this._options.index).focus();
                  break;
                // Enter

                case 13: // Space

                case 32:
                  if (!this._$input || !this._$input.is(':focus')) {
                    event.preventDefault();

                    var $option = this._$options.add(this._$value).filter(':focus');

                    $option.trigger('click');

                    if (!$option.is(this._$value)) {
                      this._$select.trigger('change');
                    }

                    this._$value.focus();
                  }

                  break;
                // Esc

                case 27:
                  event.preventDefault();

                  this._hide();

                  this._$value.focus();

                  break;

                default:
                  break;
              }
            }
            /**
             * Creates jQuery plugin function.
             *
             * @param {(Object|string)=} config Options or method.
             * @returns {Function} jQuery plugin.
             */
            ;

            CustomSelect._jQueryPlugin = function _jQueryPlugin(config) {
              return this.each(function () {
                var $this = $(this);
                var data = $this.data('custom-select');

                if (!data) {
                  if (typeof config !== 'string') {
                    data = new CustomSelect(this, config);
                    $this.data('custom-select', data);
                  }
                } else {
                  if (config === 'reset') {
                    data.reset();
                  }
                }
              });
            };

            return CustomSelect;
          }();

          $.fn['customSelect'] = CustomSelect._jQueryPlugin;

          $.fn['customSelect'].noConflict = function () {
            return $.fn['customSelect'];
          };

          return CustomSelect;
        }($);

        $('.custom-select select').customSelect();

        var logo_swiper = new Swiper('#logo-swiper.swiper-container', {
          autoplay: {
            delay: 0,
          },
          slidesPerColumn: 4,
          slidesPerView: 4,
          speed: 3000,
          spaceBetween: 25,
          disableOnInteraction: false,
          breakpoints: {
            470: {
              slidesPerView: 1.5,
              autoplay: false,
            },
            601: {
              speed: 500,
              slidesPerView: 2.6,
              autoplay: false,
            },
            900: {
              speed: 500,
              slidesPerView: 3.6,
              autoplay: false,
            },
          },
        });

        var appHeight = function appHeight() {
          var doc = document.documentElement;
          doc.style.setProperty('--app-height', ''.concat(window.innerHeight, 'px'));
        };
        window.addEventListener('resize', appHeight);
        appHeight();

        tileHeight();

        $(window).resize(function () {
          tileHeight();
        });

        $('#header').hover(function () {
          $('.home header.page-top').toggleClass('color-top');
        });
        
        // Start Menu-Aim
        function activateSubmenu(row) {
          var $row = $(row);
          var $submenu = $row.find('.sub-menu');

          $row.addClass('active-aim active-sub-item');

          if ($submenu.length) {
            var submenuHeight = $submenu.height() + 64;
            $('.center-navigation-column').css({ 'height': submenuHeight });
          }
        }

        function deactivateSubmenu(row) {
          var $row = $(row);

          $row.removeClass('active-aim active-sub-item');
          $('.center-navigation-column').css({ 'height': 'auto' });
        }

        function initMenuAim() {
          $('.main-navigation-item').off('.menuAim');

          $('.main-navigation-item').menuAim({
            activate: activateSubmenu,
            deactivate: deactivateSubmenu
          });
        }

        function activateSubmenuLevel2(row) {
          var $row = $(row);
          var $submenu = $row.find('.sub-menu');

          $row.addClass('active-aim active-sub-item');

          if ($submenu.length) {
            var submenuHeight = $submenu.height() + 64;
            $row.closest('.sub-menu').css({ 'min-height': submenuHeight });
          }
        }

        function deactivateSubmenuLevel2(row) {
          var $row = $(row);

          $row.removeClass('active-aim active-sub-item');
          $row.closest('.sub-menu').css({ 'min-height': '' });
        }

        function initMenuAimLevel2() {
          $('.main-navigation-item .sub-menu').off('.menuAimLevel2');

          $('.main-navigation-item .sub-menu').menuAim({
            activate: activateSubmenuLevel2,
            deactivate: deactivateSubmenuLevel2
          });
        }

        initMenuAim();
        initMenuAimLevel2();

        $('.sub-navigation-drop').on('mouseleave', function () {
          $('.main-navigation-item .menu-item').removeClass('active-aim active-sub-item');
          $('.center-navigation-column').css('height', 'auto');
          $('.sub-menu').css('min-height', '');

          initMenuAim();
          initMenuAimLevel2();
        });
        // End Menu-Aim

        var body_width = $('body').width();

        // Don't open top-level URLs
        if (body_width > 1279) {
          $('.acc-opener').removeAttr('href');
        }


        // Special click handlers for small screens
        if (body_width < 1280) {
          if ($('.main-navigation')) {
            $('.main-navigation-list .acc-opener').click(function () {
              if ($(this).parent().hasClass('active')) {
                $('.acc-holder').removeClass('active');
                $('.acc-holder .sub-navigation-drop').slideUp();
              } else {
                $('.acc-holder').removeClass('active');
                $(this).parent().addClass('active');
                $('.acc-holder .sub-navigation-drop').slideUp();
                $(this).parent().find('.sub-navigation-drop').slideDown();
              }
              return false;
            });
          }

          if ($('.main-navigation-item')) {
            $('.main-navigation-item .menu-item-has-children > a').click(function () {
              let $parent = $(this).parent();
              let $submenu = $parent.children('.sub-menu');
          
              if ($parent.hasClass('active')) {
                $parent.removeClass('active');
                $submenu.slideUp();
              } else {
                $parent.siblings('.menu-item-has-children').removeClass('active')
                       .children('.sub-menu').slideUp();
          
                $parent.addClass('active');
                $submenu.slideDown();
              }
          
              return false;
            });
          }
        }

        function tileHeight() {
          if ($('.tile-item').length) {
            var colh = 0;
            $('.info-tile').each(function () {
              var h_colw = parseInt($(this).outerHeight());
              if (h_colw > colh) {
                colh = h_colw;
              }

            });
            var colhEnd = colh;
            $('.tile-item').css('height', colh);
          }
        }

        if ($('.filter-holder').length) {
          const $filterHolder = $('.filter-holder');
          const $form = $filterHolder.is('form') ? $filterHolder : $filterHolder.find('form');
          const $filter = $form.find('[name=filter]');
          const $filterType = $form.find('[name=filter-type]');
          const $filterTag = $form.find('[name=filter-tag]');
          const $order = $form.find('[name=order]');
          if ($filter.is('select')) {
            $filter.on('change', function () {
              $form.submit();
            });
          }
          if ($filterType.is('select')) {
            $filterType.on('change', function () {
              $form.submit();
            });
          }
          if ($filterTag.is('select')) {
            $filterTag.on('change', function () {
              $form.submit();
            });
          }
          if ($order.length) {
            $order.on('change', function () {
              $form.submit();
            });
          }
        }

        const $contactForm = $('#mktoForm_1975');
        const $gatedContentForm = $('[data-gated-content-form]');

        if ($contactForm.length > 0 || $gatedContentForm.length > 0) {
          const $form = $contactForm.length > 0 ? $contactForm : $gatedContentForm;

          MktoForms2.whenReady(function (form) {
            if (form.getFormElem().is($form)) {
              const $button = $form.find('button[type=submit]');
              const validatedEmailsCache = new Set();
              var validationRequest = null;

              form.onSubmit(function () {
                const formValues = form.getValues();
                const email = formValues['Email'];

                if (formValues['I_am__c'] === 'Biopharma/Biotech' && !validatedEmailsCache.has(email)) {
                  form.submittable(false);
                  if (validationRequest) {
                    validationRequest.abort();
                  }
                  validationRequest = $.ajax({
                    type: 'POST',
                    url: ajaxurl,
                    data: {
                      'action': 'email_domain_validation',
                      'email': email,
                    },
                    encode: true,
                  }).always(function (data) {
                    form.submittable(true);
                    validationRequest = null;
                  }).done(function () {
                    validatedEmailsCache.add(email);
                    form.submit();
                  }).error(function () {
                    const emailField = form.getFormElem().find('#Email');
                    form.showErrorMessage('A valid company email address is required.', emailField);
                    emailField[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                  });
                  return false;
                }

                //implementing special logic for a contact form when user selects "I'm a patient"
                if ($form.is($contactForm) && formValues['I_am__c'] === 'Patient') {
                  const $buttonClone = $button.clone().prop('disabled', true).text('Please wait...');
                  $button.parent().append($buttonClone);
                  $button.detach();
                  form.submittable(false);

                  const interestedInFormatted = formValues['I_am_interested_in__c'];
                  const sourcePage = $form.attr('data-source');
                  const formData = {
                    'action': 'sfdc_patient_form_submission',
                    'first_name': formValues['FirstName'],
                    'last_name': formValues['LastName'],
                    'email': email,
                    'interested_in': interestedInFormatted,
                    'description': formValues['MktoPersonNotes'],
                    'source_page': sourcePage || '',
                  };

                  $.ajax({
                    type: 'POST',
                    url: ajaxurl,
                    data: formData,
                    encode: true,
                  }).always(function (data) {
                    $buttonClone.parent().append($button);
                    $buttonClone.remove();
                    form.submittable(true);
                  }).done(function () {
                    const $confirmForm = $('#confirmForm');
                    if ($confirmForm.length > 0) {
                      $confirmForm.show();
                      $form.hide();
                      $confirmForm[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                  });
                  return false;
                }
              });
            }
          });
          MktoForms2.onFormRender(function (form) {
            if (form.getFormElem().is($form) && $form.is($contactForm)) {
              const formValues = form.getValues();
              const $interestedInRow = $('#I_am_interested_in__c').closest('.mktoFormRow').next();

              $interestedInRow.removeAttr('hidden');
              if (formValues['I_am__c'] === 'Patient') {
                $interestedInRow.attr('hidden', 'hidden');
              }

              $form.on('change', function () {
                let score = 0;
                $form.find('select').each(function () {
                  const id = $(this).attr('id');
                  const value = $(this).val();

                  if (id === 'State') {
                    if (value === 'New York') {
                      score++;
                    }
                  }
                  if (id === 'I_am__c') {
                    if (value === 'Provider or Health System') {
                      score++;
                    }
                  }
                  if (id === 'I_am_interested_in__c') {
                    if (value === 'Neurology/Psychiatry') {
                      score++;
                    }
                  }
                });

                // special message for New York
                const $confirmForm = $('<p id="newYorkMessage" class="mktoClear" style="display: block; margin: 20px 0; font-size: 14px; line-height: 24px; padding: 0; text-align: left;"><b>Thank you for your interest in Tempus</b>.<br>\n' +
                  'Our PGx test is available in 49 U.S. states, but we are not yet available in the state of New York. We look forward to hearing from you on any additional question(s) you may have.</p>');
                $form.find('#newYorkMessage').detach();
                if (score === 3) {
                  $form.find('#InstructI_am_interested_in__c').before($confirmForm);
                }

              });
            }
          });
        }
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        if ($('#banner-video').length > 0) {
          $('#banner-video')[0].play();
          console.log('test');
        }

        $('.asco-banner .close').on('click', function () {
          $('.asco-banner').addClass('closed');
          document.cookie = 'asco=hide';
        });
      },
    },

    page_template_template_home_animation: {
      init: function () {
        $('.lightbox').each(function () {
          $(this).find('video').get(0).pause();
        });

        $('.open-video__watch').on('click', function (event) {
          event.preventDefault();
          var team = $(this).attr('href');

          $(team).fadeIn(0);
          $('body').addClass('open-lightbox');

          $('.lightbox').find('video').get(0).pause();

          if ($(team).find('video').length) {
            $(team).find('video').get(0).play();
          }
        });

        $('.lightbox .close-medium__watch').on('click', function () {
          $('body').removeClass('open-lightbox');
          $('.lightbox').fadeOut(0);
          $('.page-overlay').hide();
          var vid = jQuery(this).closest('.lightbox').find('iframe[src*="youtube"]');
          if (vid.length > 0) {
            var src = vid.attr('src');
            vid.attr('src', '');
            vid.attr('src', src);
          }

          $(this).closest('.lightbox').find('video').get(0).pause();

        });

        if ($('.page-template-template-home-animation')) {

          if (document.cookie.indexOf('tempus-return-visit') !== -1) {
            $('.loading-animation ').addClass('loaded-block');
            $('body').removeClass('no-scroll');
          } else {
            document.cookie = 'tempus-return-visit=1; max-age=604800';

            $('body').addClass('no-scroll');

            setTimeout(function () {
              $('.logo-anime-wrap').addClass('active');
            }, 100);
            setTimeout(function () {
              $('.svg-anime').addClass('black');
            }, 400);
            setTimeout(function () {
              $('.svg-anime-wrap').addClass('no-hight');
            }, 1370);
            setTimeout(function () {
              $('.logo-anime-wrap').addClass('no-zoom');
            }, 1080);
            setTimeout(function () {
              $('.logo-anime-wrap').addClass('loading');
            }, 1800);
            setTimeout(function () {
              $('.loading-animation ').addClass('loaded-block');
              $('body').removeClass('no-scroll');
            }, 3000);
          }

          // var controller = new ScrollMagic.Controller();

          // var scene = new ScrollMagic.Scene({
          //   triggerElement: '.show-content-area-top',
          //   duration: 0,
          //   triggerHook: .55,
          // }).setTween('.middle-content-anime .box.start-a', 1, { opacity: 1, bottom: 0 }).addTo(controller);

          // var scene = new ScrollMagic.Scene({
          //   triggerElement: '.show-content-area-top',
          //   duration: 0,
          //   triggerHook: .55,
          // }).setTween('.middle-content-anime .box.start-a1', 1, { opacity: 1, bottom: 0 }).addTo(controller);

          // var scene = new ScrollMagic.Scene({
          //   triggerElement: '.video-bottom-bg-block',
          //   duration: 0,
          //   triggerHook: 1,
          // }).setClassToggle('.video-area-wrapper-block', 'bottom-fixed-bg').addTo(controller);
        }

        $('.ai-tech-acc-opener').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.ai-tech-acc-opener').removeClass('open');
            $('.ai-tech-acc-opener').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });
      },
      finalize: function () {

        $(window).on('resize', function () {
          fixWidth();
        });

        fixWidth();

        function fixWidth() {
          $('.featured-item').each(function () {
            var item = $('.featured-item').width();

            $(this).find('.content-item h3').css('width', item - 80);
            $(this).find('.content-item p').css('width', item - 80);
          });
        };

        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.ai-tech-component .tabs-list li.active');
        });

        $('.ai-tech-component .tabs-list ul a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 991) {
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.ai-tech-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.ai-tech-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.ai-tech-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });

        const $chatInput = $('.orb-chat-text');


        if ($chatInput.length > 0) {
            $chatInput.on('click touchstart', function () {
                $('body').addClass('active-chat');
            });
        }

        $('.backup-button').on('click', function(e) {
          e.preventDefault();
          const target = $('#video-area-wrapper-block');

          if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 63
            }, 500);
          }
        });

        // Chat UX Tweaks for Mobile (Home)
        // Remove programmatic auto-focus immediately after textarea appears
        const root = document.querySelector("#wp-home-ai-root");

        if (root) {
          const observer = new MutationObserver(() => {
            const textarea = root.querySelector("textarea");

            if (textarea && document.activeElement === textarea) {
              textarea.blur(); // prevent auto scroll caused by initial focus
              observer.disconnect();
            }
          });

          observer.observe(root, { childList: true, subtree: true });
        }

        // Handle focus (user taps into textarea)
        document.addEventListener("focusin", (e) => {
          const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
          const homeSection = document.querySelector(".home-hero-section");

          if (
            !isMobile ||
            e.target.tagName.toLowerCase() !== "textarea" ||
            !document.body.classList.contains("home") ||
            !document.querySelector("#wp-home-ai-root")?.contains(e.target) ||
            !homeSection
          ) {
            return;
          }

          // Delay scroll to allow the keyboard to appear
          requestAnimationFrame(() => {
            setTimeout(() => {
              homeSection.scrollIntoView({
                block: "end",
                behavior: "smooth"
              });
            }, 400);
          });
        });

        // Handle blur (keyboard closes)
        document.addEventListener("focusout", (e) => {
          const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

          if (
            !isMobile ||
            e.target.tagName.toLowerCase() !== "textarea" ||
            !document.body.classList.contains("home") ||
            !document.querySelector("#wp-home-ai-root")?.contains(e.target)
          ) {
            return;
          }

          // Reset scroll when keyboard closes
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 700);
        });
      },
    },

    // Home page
    page_template_template_home: {
      init: function () {
        // JavaScript to be fired on all pages

        $(window).on('load', function () {
          $('.video-banner .video-wrapper').addClass('on');
          setTimeout(function () {
            $('.banner h1').addClass('on');
          }, 100);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 600);
        });

        $('.vertical-list-content-section .title').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });

        $('.vertical-list-content-section .copy').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });

        var fixedElementOffset = $('.vertical-title span').offset().top;
        var footerOffset;
        if ($('.home-quote-section').length > 0) {
          footerOffset = $('.home-quote-section').offset().top;
        } else {
          footerOffset = $('.cta-section').offset().top;
        }
        var fixedElementHeight = $('.vertical-title span').height();

        $(window).scroll(function (event) {
          var y = $(this).scrollTop() + 150;
          if (
            y >= fixedElementOffset &&
            y + fixedElementHeight < footerOffset
          ) {
            var line_left = $('.vertical-title span').offset().left;
            $('.vertical-title span').css('left', line_left);
            $('.vertical-title span').addClass('fixed');
            $('.vertical-title span').removeClass('bottom');
          } else if (
            y >= fixedElementOffset &&
            y + fixedElementHeight >= footerOffset
          ) {
            $('.vertical-title span').css('left', '0');
            $('.vertical-title span').removeClass('fixed');
            $('.vertical-title span').addClass('bottom');
          } else {
            $('.vertical-title span').css('left', '0');
            $('.vertical-title span').removeClass('fixed bottom');
          }
        });

        $(window).resize(function () {
          var line_left = $('.vertical-title span').offset().left;
          line_left = line_left;
          $('.vertical-title span').css('left', line_left);
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // Products page
    page_template_template_products: {
      init: function () {
        // JavaScript to be fired on all pages

        $(window).on('load', function () {
          $('.white-video-banner .video-wrapper').addClass('on');
          $('.white-video-banner .overlay').addClass('on');
          $('.banner h1').addClass('on');
          $('.banner p').addClass('on');
        });

        $('.line-title').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // Analytics Insights page
    page_template_template_analytics_insights: {
      init: function () {
        // JavaScript to be fired on all pages

        $(window).on('load', function () {
          $('.banner .video-wrapper').addClass('on');
          setTimeout(function () {
            $('.banner h1').addClass('on');
          }, 100);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 600);
        });

        $('.line-title').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });

        $('.down-line').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // Analytics Tools page
    page_template_template_analytics_tools: {
      init: function () {
        // JavaScript to be fired on all pages

        $('.down-line').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // About page
    page_template_template_about: {
      init: function () {
        // JavaScript to be fired on all pages

        $(window).on('load', function () {
          $('.banner .video-wrapper').addClass('on');
          setTimeout(function () {
            $('.banner h1').addClass('on');
          }, 100);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 600);

        });

        $('.line').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });

        if ($('.slider-section .row').length > 0) {
          $('.slider-section .row').each(function (e) {
            var reveal = $(this);
            var waypoint_reveal = new Waypoint({
              element: reveal[0],
              handler: function (direction) {
                if (direction === 'down') {
                  reveal.addClass('on');
                }
              },
              offset: '90%',
            });
          });
        }

        var team_swiper = new Swiper('#team-slider.swiper-container', {
          autoplay: {
            delay: 0,
          },
          slidesPerView: 'auto',
          loop: true,
          speed: 2000,
          spaceBetween: 25,
          disableOnInteraction: false,
          breakpoints: {},
        });
        team_swiper.autoplay.stop();

        $('#team-slider.swiper-container').hover(
          function () {
            team_swiper.autoplay.start();
          },
          function () {
            team_swiper.autoplay.stop();
          },
        );

        var careers_swiper = new Swiper('#careers-slider.swiper-container', {
          autoplay: {
            delay: 0,
          },
          slidesPerView: 'auto',
          loop: true,
          speed: 2000,
          spaceBetween: 25,
          disableOnInteraction: false,
          breakpoints: {},
        });

        careers_swiper.autoplay.stop();

        $('#careers-slider.swiper-container').hover(
          function () {
            careers_swiper.autoplay.start();
          },
          function () {
            careers_swiper.autoplay.stop();
          },
        );

        var culture_swiper = new Swiper('#culture-slider.swiper-container', {
          autoplay: {
            delay: 0,
          },
          slidesPerView: 'auto',
          loop: true,
          speed: 2000,
          spaceBetween: 25,
          disableOnInteraction: false,
          breakpoints: {},
        });

        culture_swiper.autoplay.stop();

        $('#culture-slider.swiper-container').hover(
          function () {
            culture_swiper.autoplay.start();
          },
          function () {
            culture_swiper.autoplay.stop();
          },
        );

        var news_swiper = new Swiper('#news-slider.swiper-container', {
          autoplay: {
            delay: 0,
          },
          slidesPerView: 'auto',
          loop: true,
          speed: 2000,
          spaceBetween: 25,
          disableOnInteraction: false,
          breakpoints: {},
        });

        news_swiper.autoplay.stop();

        $('#news-slider.swiper-container').hover(
          function () {
            news_swiper.autoplay.start();
          },
          function () {
            news_swiper.autoplay.stop();
          },
        );

        var collaboration_swiper = new Swiper(
          '#collaboration-slider.swiper-container',
          {
            autoplay: {
              delay: 0,
            },
            slidesPerView: 'auto',
            loop: true,
            speed: 2000,
            spaceBetween: 25,
            disableOnInteraction: false,
            breakpoints: {},
          },
        );

        collaboration_swiper.autoplay.stop();

        $('#collaboration-slider.swiper-container').hover(
          function () {
            collaboration_swiper.autoplay.start();
          },
          function () {
            collaboration_swiper.autoplay.stop();
          },
        );
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // Clinical Data page
    page_template_template_clinical_data: {
      init: function () {
        // JavaScript to be fired on all pages
        var productSwiper;

        function prodSwiper() {
          if ($('.products-section .swiper-container')) {
            if ($(window).width() > 768) {
              if (!$('.products-section .swiper-container').hasClass('desktop')) {
                if (productSwiper) {
                  productSwiper.destroy();
                }

                $('.products-section .swiper-container').addClass('desktop');
                $('.products-section .swiper-container').removeClass('tablet');
                productSwiper = new Swiper('.products-section .swiper-container', {
                  speed: 500,
                  slidesPerView: 1,
                  autoHeight: true,
                  loop: true,
                  direction: 'vertical',
                  touchRatio: 0,
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                  on: {
                    init: function () {
                      var height = $('.swiper-slide-active').children('h2').height() +
                        $('.swiper-slide-active').children('p').height();
                      $('.products-section .swiper-container').height(height + 100);
                    },
                    slideChangeTransitionStart: function () {
                      var height = $('.swiper-slide-active').children('h2').height() +
                        $('.swiper-slide-active').children('p').height();
                      $('.products-section .swiper-container').height(height + 100);
                      var activeIndex = $('.products-section .swiper-slide-active')[0].dataset.index;
                      $('.screenshot').each(function () {
                        if ($(this)[0].dataset.index === activeIndex) {
                          $(this).addClass('active');
                        } else {
                          $(this).removeClass('active');
                        }
                      });
                    },
                  },
                });
              }

              $('.laptop').on('click', function () {
                productSwiper.slideNext();
                console.log('test');
              });

            } else if ($(window).width() > 581) {
              if (!$('.products-section .swiper-container').hasClass('tablet')) {
                if (productSwiper) {
                  productSwiper.destroy();
                  $('.products-section .swiper-container').removeAttr('style');
                }

                $('.products-section .swiper-container').addClass('tablet');
                $('.products-section .swiper-container').removeClass('desktop');
                productSwiper = new Swiper('.products-section .swiper-container', {
                  speed: 500,
                  slidesPerView: 1,
                  touchRatio: 0,
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                  loop: true,
                  on: {
                    slideChangeTransitionStart: function () {
                      var activeIndex = $('.products-section .swiper-slide-active')[0].dataset.index;
                      $('.screenshot').each(function () {
                        if ($(this)[0].dataset.index === activeIndex) {
                          $(this).addClass('active');
                        } else {
                          $(this).removeClass('active');
                        }
                      });
                    },
                  },
                });
              }

              $('.screenshot, .swiper-slide').on('click', function () {
                productSwiper.slideNext();
                console.log('test');
              });
            }
          }
        }

        $(window).on('load', function () {
          setTimeout(function () {
            $('.banner h1').addClass('on');
          }, 100);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 600);
          prodSwiper();
        });

        $(window).on('resize', function () {
          prodSwiper();
        });

        $('.data-list-section').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                console.log(this.element);
                $('.fixed-scroll-section').addClass('bottom');
              }
              if (direction === 'up') {
                $('.fixed-scroll-section').removeClass('bottom');
              }
            },
            offset: '100%',
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // Image Recognition page
    page_template_template_image_recognition: {
      init: function () {
        // JavaScript to be fired on all pages

        $(window).on('load', function () {
          setTimeout(function () {
            $('.banner h1').addClass('on');
          }, 100);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 600);
        });

        $('.line-left').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });

        $('.line-right').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_our_oncologistic: {
      init: function () {
        // JavaScript to be fired on all pages
        $(window).on('load', function () {
          setTimeout(function () {
            $('.banner h1').addClass('on');
          }, 200);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 600);
        });

        var collaboration_swiper = new Swiper(
          '#collaboration-slider.swiper-container',
          {
            autoplay: {
              delay: 0,
            },
            slidesPerView: 'auto',
            loop: true,
            speed: 2000,
            spaceBetween: 25,
            disableOnInteraction: false,
            breakpoints: {},
          },
        );

        collaboration_swiper.autoplay.stop();

        $('#collaboration-slider.swiper-container').hover(
          function () {
            collaboration_swiper.autoplay.start();
          },
          function () {
            collaboration_swiper.autoplay.stop();
          },
        );

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        var awardsSwiper = new Swiper('#careers-slider.awards-section .swiper-container', {
          slidesPerView: 'auto',
          centeredSlides: true,
          a11y: true,
          loop: true,
          spaceBetween: 110,
          simulateTouch: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            920: {
              spaceBetween: 100,
            },
            680: {
              spaceBetween: 40,
            },
          },
        });

        $('.open-video-sl').on('click', function (event) {
          event.preventDefault();

          $('.lightbox').fadeOut(0);
          var id = $(this).attr('href');
          $(id).fadeIn(0);

          return false;
        });

        $('.lightbox .close').on('click', function () {
          $('.lightbox').fadeOut(0);
          $('.page-overlay').hide();

          var vid = jQuery(this).closest('.lightbox').find('iframe[src*="youtube"]');
          if (vid.length > 0) {
            var src = vid.attr('src');
            vid.attr('src', '');
            vid.attr('src', src);
          }
        });
      },
    },
    page_template_template_our_reserchers: {
      init: function () {
        // JavaScript to be fired on all pages
        $(window).on('load', function () {
          setTimeout(function () {
            $('.banner .page-name').addClass('on');
          }, 100);
          setTimeout(function () {
            $('.banner h1').addClass('on');
          }, 300);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 600);
        });

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_our_psychiatrists: {
      init: function () {
        // JavaScript to be fired on all pages

        $(window).on('load', function () {
          setTimeout(function () {
            $('.banner h1').addClass('on');
          }, 100);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 600);
        });

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // Clinical Decision Support page
    page_template_template_clinical_decision_support: {
      init: function () {
        // JavaScript to be fired on all pages

        $(window).on('load', function () {
          setTimeout(function () {
            $('.banner h3').addClass('on');
          }, 10);
          setTimeout(function () {
            $('.banner h2').addClass('on');
          }, 100);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 600);
        });

        var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

        function preventDefault(e) {
          e = e || window.event;
          if (e.preventDefault) e.preventDefault();
          e.returnValue = false;
        }

        function preventDefaultForScrollKeys(e) {
          if (keys[e.keyCode]) {
            preventDefault(e);
            return false;
          }
        }

        function disableScroll() {
          if (window.addEventListener)
            // older FF
            window.addEventListener('DOMMouseScroll', preventDefault, false);
          window.onwheel = preventDefault; // modern standard
          window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
          window.ontouchmove = preventDefault; // mobile
          document.onkeydown = preventDefaultForScrollKeys;
        }

        function enableScroll() {
          if (window.removeEventListener)
            window.removeEventListener('DOMMouseScroll', preventDefault, false);
          window.onmousewheel = document.onmousewheel = null;
          window.onwheel = null;
          window.ontouchmove = null;
          document.onkeydown = null;
        }

        var quote_swiper = new Swiper(
          '.mobile-black-fixed-scroll-section .swiper-container',
          {
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            speed: 2000,
            spaceBetween: 100,
            loopAdditionalSlides: 1,
            disableOnInteraction: false,
            breakpoints: {},
          },
        );

        //Center Images In Container
        function centerImage(imageContainer) {
          //set size
          var th = imageContainer.height(),//box height
            tw = imageContainer.width(),//box width
            im = imageContainer.children('img'),//image
            ih = im.height(),//inital image height
            iw = im.width();//initial image width

          if ((th / tw) > (ih / iw)) {
            im.addClass('wh').removeClass('ww');//set height 100%
          } else {
            im.addClass('ww').removeClass('wh');//set width 100%
          }

          //set offset
          var nh = im.height(),//new image height
            nw = im.width(),//new image width
            hd = (nh - th) / 1.5,//half dif img/box height
            wd = (nw - tw) / 2;//half dif img/box width
          if (hd < 1) {
            hd = 0;
          }
          if (wd < 1) {
            wd = 0;
          }
          im.css({ marginLeft: '-' + wd + 'px', marginTop: '-' + hd + 'px' });//offset left
        }

        if ($('.screenshot').length > 0) {
          $('.screenshot').each(function () {
            centerImage($(this));
          });
        }

        $('.end-fixed-scroll').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                $('.black-fixed-scroll-section').addClass('bottom');
              }
              if (direction === 'up') {
                $('.black-fixed-scroll-section').removeClass('bottom');
              }
            },
            offset: '100%',
          });
        });

        $('.under-line').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });

        $('.graphic').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_ctm: {
      init: function () {
        // JavaScript to be fired on all pages
        $(window).on('load', function () {
          setTimeout(function () {
            $('.banner h3').addClass('on');
          }, 880);
          setTimeout(function () {
            $('.banner h2').addClass('on');
          }, 1200);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 1600);
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_ctm_new: {
      init: function () {
        // JavaScript to be fired on all pages
        $(window).on('load', function () {
          setTimeout(function () {
            $('.banner h3').addClass('on');
          }, 880);
          setTimeout(function () {
            $('.banner h2').addClass('on');
          }, 1200);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 1600);
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_additional_testing: {
      init: function () {
        // JavaScript to be fired on all pages
        $(window).on('load', function () {
          setTimeout(function () {
            $('.banner .page-name ').addClass('on');
          }, 380);
          setTimeout(function () {
            $('.banner h2').addClass('on');
          }, 700);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 1200);
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // Partners page
    page_template_template_partners: {
      init: function () {
        // JavaScript to be fired on all pages

        $('.tabbed-quote-section .tab').on('click', function () {
          $('.tabbed-quote-section .tab').removeClass('active');
          $(this).addClass('active');
          var quote = $(this).data('quote');
          $('.quote-cnt').hide();
          $('#' + quote).show();
        });

        var quote_swiper = new Swiper(
          '.mobile-tabbed-quote-section .swiper-container',
          {
            slidesPerView: 1,
            loop: true,
            speed: 2000,
            spaceBetween: 0,
            disableOnInteraction: false,
            breakpoints: {},
          },
        );
        $('.mobile-tabbed-quote-section .next').on('click', function (event) {
          quote_swiper.slideNext();
        });

        $('.logos-row .col-xs-3').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                $('.logos-row .col-xs-3').addClass('on');
              }
            },
            offset: '90%',
          });
        });

        function logos() {
          if ($(window).width() > 580) {
            var height = $('.quote-cnt').outerHeight();
            var logo_height = height / 5;
            $('.tab').css('height', logo_height);
          }
        }

        logos();

        $(window).on('load', function () {
          logos();
        });

        $(window).on('resize', function () {
          logos();
        });

        if ($(window).width() < 580) {
          $('.tabbed-quote-section .tab').on('click', function (event) {
            event.preventDefault();
            var section = $(this).attr('href');
            $('html, body').animate(
              {
                scrollTop: $('.tabbed-quote-section').offset().top,
              },
              1000,
            );
          });
        }
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        function initialize() {
          var map, lat, lng, ltlng, marker;
          var markers = [];
          var contentString = [];
          var styles = [
            {
              featureType: 'all',
              elementType: 'all',
              stylers: [{ visibility: 'on' }],
            },
            {
              featureType: 'all',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'all',
              elementType: 'labels.text',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'all',
              elementType: 'labels.text.fill',
              stylers: [
                { saturation: 36 },
                { color: '#333333' },
                { lightness: 40 },
              ],
            },
            {
              featureType: 'all',
              elementType: 'labels.text.stroke',
              stylers: [
                { visibility: 'on' },
                { color: '#ffffff' },
                { lightness: 16 },
              ],
            },
            {
              featureType: 'all',
              elementType: 'labels.icon',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'administrative',
              elementType: 'all',
              stylers: [{ visibility: 'on' }],
            },
            {
              featureType: 'administrative',
              elementType: 'geometry.fill',
              stylers: [{ color: '#fefefe' }, { lightness: 20 }],
            },
            {
              featureType: 'administrative',
              elementType: 'geometry.stroke',
              stylers: [
                { color: '#fefefe' },
                { lightness: 17 },
                { weight: 1.2 },
              ],
            },
            {
              featureType: 'administrative',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'administrative.country',
              elementType: 'geometry',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'administrative.province',
              elementType: 'geometry',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'landscape',
              elementType: 'geometry',
              stylers: [{ color: '#f5f5f5' }, { lightness: 20 }],
            },
            {
              featureType: 'landscape',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'poi',
              elementType: 'all',
              stylers: [{ visibility: 'on' }],
            },
            {
              featureType: 'poi',
              elementType: 'geometry',
              stylers: [{ color: '#f5f5f5' }, { lightness: 21 }],
            },
            {
              featureType: 'poi',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry',
              stylers: [{ color: '#dedede' }, { lightness: 21 }],
            },
            {
              featureType: 'road',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'road',
              elementType: 'labels.text',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'road',
              elementType: 'labels.text.fill',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'road',
              elementType: 'labels.text.stroke',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.fill',
              stylers: [{ color: '#ffffff' }, { lightness: 17 }],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.stroke',
              stylers: [
                { color: '#ffffff' },
                { lightness: 29 },
                { weight: 0.2 },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'road.highway',
              elementType: 'labels.text',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'road.highway',
              elementType: 'labels.text.fill',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'road.highway',
              elementType: 'labels.text.stroke',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'road.highway.controlled_access',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'road.arterial',
              elementType: 'geometry',
              stylers: [{ color: '#ffffff' }, { lightness: 18 }],
            },
            {
              featureType: 'road.arterial',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'road.arterial',
              elementType: 'labels.text',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'road.local',
              elementType: 'geometry',
              stylers: [{ color: '#ffffff' }, { lightness: 16 }],
            },
            {
              featureType: 'road.local',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'transit',
              elementType: 'geometry',
              stylers: [{ color: '#f2f2f2' }, { lightness: 19 }],
            },
            {
              featureType: 'transit',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'transit.station',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [{ color: '#e9e9e9' }, { lightness: 17 }],
            },
            {
              featureType: 'water',
              elementType: 'labels.text',
              stylers: [{ visibility: 'off' }],
            },
          ];
          var styledMap = new google.maps.StyledMapType(styles, {
            name: 'tehgrayz',
          });
          var myOptions = {
              center: new google.maps.LatLng(40.0026763, -75.258461),
              zoom: 10.5,
              mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style'],
              },
              panControl: false,
              panControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER,
              },
              zoomControl: false,
              zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP,
              },
              fullscreenControl: false,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              overviewMapControl: false,
            },
            map = new google.maps.Map($('#map')[0], myOptions);
          map.mapTypes.set('map_style', styledMap);
          map.setMapTypeId('map_style');

          var infowindow = new google.maps.InfoWindow();
          var bound = new google.maps.LatLngBounds();

          for (var i = 0; i < locations.length; i++) {
            lat = locations[i].lat;
            lng = locations[i].lng;
            ltlng = new google.maps.LatLng(lat, lng);
            marker = new google.maps.Marker({
              position: new google.maps.LatLng(
                locations[i].lat,
                locations[i].lng,
              ),
              icon: 'http://frontend.tempus.sandbox5.cliquedomains.com/images/pin.png',
              animation: google.maps.Animation.DROP,
              map: map,
            });
            markers.push(marker);

            for (var i in markers) {
              bound.extend(markers[i].getPosition());
            }
            map.fitBounds(bound);
          }
        }

        $('.open-video-1').on('click', function (event) {
          $('.lightbox-1').fadeIn(0);
          console.log('vid1');
        });

        $('.open-video-2').on('click', function (event) {
          $('.lightbox-2').fadeIn(0);
          console.log('vid2');
        });

        $('.open-video-3').on('click', function (event) {
          $('.lightbox-3').fadeIn(0);
          console.log('vid3');
        });

        $('.lightbox-1 .close').on('click', function () {
          $('.lightbox-1').fadeOut(0);
          $('.page-overlay').hide();
          var vid = jQuery('.lightbox-1 iframe[src*="youtube"]');
          if (vid.length > 0) {
            var src = vid.attr('src');
            vid.attr('src', '');
            vid.attr('src', src);
          }
        });
        $('.lightbox-2 .close').on('click', function () {
          $('.lightbox-2').fadeOut(0);
          $('.page-overlay').hide();
          var vid = jQuery('.lightbox-2 iframe[src*="youtube"]');
          if (vid.length > 0) {
            var src = vid.attr('src');
            vid.attr('src', '');
            vid.attr('src', src);
          }
        });
        $('.lightbox-3 .close').on('click', function () {
          $('.lightbox-3').fadeOut(0);
          $('.page-overlay').hide();
          var vid = jQuery('.lightbox-3 iframe[src*="youtube"]');
          if (vid.length > 0) {
            var src = vid.attr('src');
            vid.attr('src', '');
            vid.attr('src', src);
          }
        });
      },
    },

    // Our Team page
    page_template_template_our_team: {
      init: function () {
        // JavaScript to be fired on all pages

        $(window).on('load', function () {
          setTimeout(function () {
            $('.banner h1').addClass('on');
          }, 100);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 600);
          setTimeout(function () {
            $('.banner a').addClass('on');
          }, 1200);
        });

        $('.people-section').each(function (i) {
          $('#people-' + i + ' .team-cnt').each(function (index) {
            $(this).css({ 'transition-delay': 0.2 * (1 + index) + 's' });
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // Careers page
    page_template_template_careers: {
      init: function () {
        // JavaScript to be fired on all pages

        if ($('.job-list').length > 0) {
          $('.job-list').each(function (e) {
            var reveal = $(this);
            var waypoint_reveal = new Waypoint({
              element: reveal[0],
              handler: function (direction) {
                if (direction === 'down') {
                  reveal.addClass('on');
                }
              },
              offset: '90%',
            });
          });
        }
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    page_template_template_careers_new: {
      init: function () {
        // JavaScript to be fired on all pages

        if ($('.job-list').length > 0) {
          $('.job-list').each(function (e) {
            var reveal = $(this);
            var waypoint_reveal = new Waypoint({
              element: reveal[0],
              handler: function (direction) {
                if (direction === 'down') {
                  reveal.addClass('on');
                }
              },
              offset: '90%',
            });
          });
        }
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        var awardsSwiper = new Swiper('#careers-slider.awards-section .swiper-container', {
          slidesPerView: 'auto',
          centeredSlides: true,
          a11y: true,
          loop: true,
          spaceBetween: 110,
          simulateTouch: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            920: {
              spaceBetween: 100,
            },
          },
        });

        $('.open-video-sl').on('click', function (event) {
          event.preventDefault();

          $('.lightbox').fadeOut(0);
          var id = $(this).attr('href');
          $(id).fadeIn(0);

          return false;
        });

        $('.lightbox .close').on('click', function () {
          $('.lightbox').fadeOut(0);
          $('.page-overlay').hide();

          var vid = jQuery(this).closest('.lightbox').find('iframe[src*="youtube"]');
          if (vid.length > 0) {
            var src = vid.attr('src');
            vid.attr('src', '');
            vid.attr('src', src);
          }
        });
      },
    },

    // Culture page
    page_template_template_culture: {
      init: function () {
        // JavaScript to be fired on all pages

        $(window).on('load', function () {
          setTimeout(function () {
            $('.banner h1').addClass('on');
          }, 100);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 600);
          setTimeout(function () {
            $('.banner a').addClass('on');
          }, 1200);
        });

        if ($('.benefits-section').length > 0) {
          $('.benefits-section').each(function (e) {
            var reveal = $(this);
            var waypoint_reveal = new Waypoint({
              element: reveal[0],
              handler: function (direction) {
                if (direction === 'down') {
                  reveal.addClass('on');
                }
              },
              offset: '90%',
            });
          });
        }
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        //Tempus Culure Code Section

        //Autoscrolling

        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.code-container .tabs li.active');
        });

        $('.code-section .tabs a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.code-section .tabs li').removeClass('active');
              tab.addClass('active');

              $('.code-section .code').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.code-section .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.code-section .tabs li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-code').addClass('active');
              } else {
                $(this).children('.mobile-code').removeClass('active');
              }
            });
          }
        });

        $(window).on('resize', function () {
          if ($(window).width() > 681) {
            $('.code-section .tabs li, .code-section .tabs li .mobile-code').removeClass('active');
            activeTab.addClass('active');
            $('.code-section .code').each(function () {
              if (activeTab[0].dataset.code === $(this)[0].dataset.code) {
                $(this).addClass('active');
              } else {
                $(this).removeClass('active');
              }
            });
            $('.code-section .code-pagination a').each(function () {
              if ($(this)[0].dataset.code === activeTab[0].dataset.code) {
                $(this).addClass('active');
              } else {
                $(this).removeClass('active');
              }
            });
          } else {
            $('.code-section .tabs li, .code-section .tabs li .mobile-code').removeClass('active');
            $('.code-section .code').removeClass('active');
          }
        });

        //Pagination

        $('.code-section .code-pagination a').on('click', function (e) {
          var tab = $(this);
          var code = tab[0].dataset.code;

          if (!tab.hasClass('active')) {
            $('.code-section .code-pagination a').removeClass('active');
            $(this).addClass('active');

            $('.code-section .tabs li').each(function () {
              if ($(this)[0].dataset.code === code) {
                $(this).addClass('active');
              } else {
                $(this).removeClass('active');
              }
            });

            $('.code-section .code').each(function () {
              if ($(this)[0].dataset.code === code) {
                $(this).addClass('active');
              } else {
                $(this).removeClass('active');
              }
            });

            $('.code-section .mobile-code').each(function () {
              if ($(this)[0].dataset.code === code) {
                $(this).addClass('active');
              } else {
                $(this).removeClass('active');
              }
            });
          }
        });

        //Awards Section
        var awardsSwiper = new Swiper('.awards-section .swiper-container', {
          slidesPerView: 'auto',
          centeredSlides: true,
          a11y: true,
          loop: true,
          spaceBetween: 110,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            920: {
              spaceBetween: 100,
            },
            681: {
              spaceBetween: 0,
              touchRatio: 0,
            },
          },
        });

      },
    },

    // Data Solutions page
    page_template_template_data_solutions: {
      init: function () {
        // JavaScript to be fired on all pages
        console.log('js test');

        $(window).on('load', function () {
          setTimeout(function () {
            $('.banner h1').addClass('on');
          }, 100);
          setTimeout(function () {
            $('.banner p').addClass('on');
          }, 600);
          setTimeout(function () {
            $('.banner a').addClass('on');
          }, 1200);
        });

        $('.blue-line-mobile').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });

        //Logo Animation
        function logoAnimation(logoTop) {
          var scrollTop = $(window).scrollTop();
          var quoteSectionTop = $('.quote-section').offset().top;
          var quoteSectionHeight = $('.quote-section').height();
          var logoHeight = $('.quote-section .company').height();
          if (scrollTop >= logoTop) {
            var newTop = scrollTop - logoTop;
            if (newTop <= quoteSectionHeight - logoHeight) {
              $('.quote-section .company').css('top', newTop);
            }
          }
        }

        $(window).on('resize', function () {
          var logoTop = $('.quote-section .cnt').offset().top;
          logoAnimation(logoTop);
        });

        $(document).on('scroll', function () {
          var logoTop = $('.quote-section .cnt').offset().top;
          logoAnimation(logoTop);
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // News page
    page_template_template_news: {
      init: function () {
        // JavaScript to be fired on all pages

        // if (window.location.href.indexOf("post-search") > -1) {
        $('.banner h1').addClass('pre-on');
        $('.banner form').addClass('pre-on');
        $('.banner p').addClass('pre-on');
        $('.banner a').addClass('pre-on');
        // } else {
        //   $(window).on("load", function() {
        //     $(".banner h1").addClass("on");
        //     $(".banner form").addClass("on");
        //     $(".banner p").addClass("on");
        //     $(".banner a").addClass("on");
        //   });
        // }
        /*$("input[type=search]").on("search", function () {
                  if (window.location.href.indexOf("post-search") > -1) {
                      document.location.href = "/news";
                  }
              });*/
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('body').on('click', '.top-nav-tabs-news ul li', function () {
          $('.top-nav-tabs-news ul li').removeClass('active');
          $(this).addClass('active');
          var tab = $(this).data('href');
          $('.all-tabs-area .tab-block').addClass('hidden');
          $('#' + tab + '').removeClass('hidden');
        });
        // JavaScript to be fired on all pages, after page specific JS is fired
        if ($('.more').hasClass('hidden')) {
          $(this).hide();
        }
        $('.more').on('click', function (e) {
          e.preventDefault();
          var $moreClick = $(this);
          var $container = $(this).parent().find('.news-container');
          var offset = $container.data('post-count');
          var data = $(this).attr('data');

          if (!data) {
            data = false;
          }
          $.ajax({
            url: ajaxurl,
            method: 'POST',
            data: { offset: offset, data: data, action: 'more_posts' },
            success: function (data) {
              if (data !== '0') {
                $container.append(data);
                var count = $container.children().length;
                if (count >= $container.data('total-posts')) {
                  $moreClick.hide();
                }
                var postCount = parseInt(
                  $container.data('post-count'),
                );
                var newRows = $container.find('.news-item').length;
                console.log(newRows);
                if (
                  $('.reveal, .vert-reveal, .left-reveal, .laptop-reveal').length > 0
                ) {
                  $('.reveal, .vert-reveal, .left-reveal, .laptop-reveal').each(
                    function (e) {
                      var reveal = $(this);
                      var waypoint_reveal = new Waypoint({
                        element: reveal[0],
                        handler: function (direction) {
                          if (direction === 'down') {
                            reveal.addClass('on');
                          }
                        },
                        offset: '77%',
                      });
                    },
                  );
                }
                // the commented out version below wasn't working so I took out postCount - leaving it case of revert.
                // $(".news-container").data("post-count", postCount + newRows);
                $container.data('post-count', newRows);
              }
            },
          });
        });
      },
    },

    page_template_template_publications: {
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        if ($('.more').hasClass('hidden')) {
          $('.more').hide();
        }
        $('.more').on('click', function (e) {
          e.preventDefault();
          var offset = $('.news-container').data('post-count');
          $.ajax({
            url: ajaxurl,
            method: 'POST',
            data: { offset: offset, action: 'more_posts_public' },
            success: function (data) {
              if (data !== '0') {
                $('.news-container').append(data);
                var count = $('.news-container').children().length;
                if (count >= $('.news-container').data('total-posts')) {
                  $('.more').hide();
                }
                var postCount = parseInt(
                  $('.news-container').data('post-count'),
                );
                var newRows = $('.news-container .news-item').length;
                if (
                  $('.reveal, .vert-reveal, .left-reveal, .laptop-reveal').length > 0
                ) {
                  $('.reveal, .vert-reveal, .left-reveal, .laptop-reveal').each(
                    function (e) {
                      var reveal = $(this);
                      var waypoint_reveal = new Waypoint({
                        element: reveal[0],
                        handler: function (direction) {
                          if (direction === 'down') {
                            reveal.addClass('on');
                          }
                        },
                        offset: '77%',
                      });
                    },
                  );
                }
                // the commented out version below wasn't working so I took out postCount - leaving it case of revert.
                // $(".news-container").data("post-count", postCount + newRows);
                $('.news-container').data('post-count', newRows);
              }
            },
          });
        });
      },
    },

    // Sequencing page
    page_template_template_sequencing: {
      init: function () {
        // JavaScript to be fired on all pages

        var top_height = $('.banner').height();
        var bottom_height = $('.lab-section.white-bg').height();
        var spacer_height = top_height + bottom_height + 100;
        $('.spacer').css('height', spacer_height + 'px');
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // Sequencing page
    page_template_template_contact: {
      init: function () {
        // JavaScript to be fired on all pages
        $('.multi select').multipleSelect({
          isopen: true,
          multiple: true,
          selectAll: false,
        });

        $('.gform_footer .button').before($('<div class="btn-cancel"><a href="/contact-us">Cancel</a></div>'));
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        /*var url_string = window.location.href;
              var url = new URL(url_string);
              var c = url.search.get("demo");
              if (c) {
                  $("#input_1_2")[0].value = "Clinician";
              }*/
      },
    },

    page_template_template_gated_webinar: {
      init: function () {
        // JavaScript to be fired on all pages
        $('.multi select').multipleSelect({
          isopen: true,
          multiple: true,
          selectAll: false,
        });

        $('.gform_footer .button').before($('<div class="btn-cancel"><a href="/contact-us">Cancel</a></div>'));
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        /*var url_string = window.location.href;
              var url = new URL(url_string);
              var c = url.search.get("demo");
              if (c) {
                  $("#input_1_2")[0].value = "Clinician";
              }*/
      },
    },

    error404: {
      init: function () {
        // JavaScript to be fired on all pages
        $('.multi select').multipleSelect({
          isopen: true,
          multiple: true,
          selectAll: false,
        });

        $('.gform_footer .button').before($('<div class="btn-cancel"><a href="/contact-us">Cancel</a></div>'));
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        /*var url_string = window.location.href;
              var url = new URL(url_string);
              var c = url.search.get("demo");
              if (c) {
                  $("#input_1_2")[0].value = "Clinician";
              }*/
      },
    },

    // Sequencing page
    page_template_template_faq: {
      init: function () {
        // JavaScript to be fired on all pages
        /*$("#Physician").show();

              $(".tabs li a").on("click", function (event) {
                  event.preventDefault();
                  var tab = $(this).attr("href");
                  $(".tabs li").removeClass("active");
                  $(this)
                      .parent()
                      .addClass("active");
                  $(".tab-cnt").hide();
                  $(tab).fadeIn(400);
              });*/
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // Document Library
    page_template_template_document_library: {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('.line-right').each(function (e) {
          var reveal = $(this);
          var waypoint_reveal = new Waypoint({
            element: reveal[0],
            handler: function (direction) {
              if (direction === 'down') {
                reveal.addClass('on');
              }
            },
            offset: '90%',
          });
        });
      },
    },

    page_template_template_app_life: {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_product_data_licensing: {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_tempus_one: {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('.faq-toggle').on('click', function (e) {
          e.preventDefault();
          $(this).toggleClass('open');
          if ($(this).hasClass('open')) {
            $(this).next().slideDown();
          } else {
            $(this).next().slideUp();
          }

          return false;
        });
      },
    },

    page_template_template_consumer: {
      init: function () {
        // JavaScript to be fired on all pages

        var testimonial_swiper = new Swiper('#testimonial-slider.swiper-container', {
          slidesPerView: 3,
          spaceBetween: 70,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 70,
            },
          },
        });

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_mega: {
      init: function () {
        // JavaScript to be fired on all pages

        var resource_swiper = new Swiper('#resource-slider', {
          slidesPerView: 1,
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.resource-swiper-pagination',
            type: 'fraction',
            // formatFractionCurrent: function (number) {
            //     return '0' + number;
            // }
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });

        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var amount_column = 2;
        var amount_logos = $('#logos-carousel.swiper-container .swiper-slide').length;

        if (amount_logos < 7) {
          amount_column = 1;
        }

        if (amount_logos < 12) {
          $('#logos-carousel.swiper-container').addClass('center-mode');
        }

        var logos_swiper = new Swiper('#logos-carousel.swiper-container', {
          // loop: true,
          runCallbacksOnInit: true,
          watchOverflow: true,
          slidesPerView: 6,
          slidesPerColumn: amount_column,
          spaceBetween: 0,
          noSwiping: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            // when window width is >= 768px
            767: {
              slidesPerView: 1,
              slidesPerColumn: 6,
              spaceBetween: 0,
            },
          },
        });
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.content-list-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.content-list-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.content-list-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_landing_life_sciences: {
      init: function () {
        // JavaScript to be fired on all pages

        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var swiper;

        function swiperCard() {
          if (window.innerWidth >= 768) {
            swiper = new Swiper('#company-cards-slider.swiper-container', {
              slidesPerView: 4,
              spaceBetween: 16,
              slidesPerGroup: 4,
              speed: 500,
              resizeReInit: true,
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              breakpoints: {
                991: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                  slidesPerGroup: 2,
                  speed: 500,
                },
                1499: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                  slidesPerGroup: 3,
                },
              },
            });

          } else {
            swiper = new Swiper('#company-cards-slider.swiper-container', {
              resizeReInit: true,
              slidesPerView: 1,
              spaceBetween: 16,
              slidesPerColumn: 2,
              slidesPerGroup: 1,
              speed: 500,
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });
          }
        }

        swiperCard();
        window.addEventListener('resize', swiperCard);

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_landing_life_sciences_v2: {
      init: function () {
        // JavaScript to be fired on all pages

        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var swiper;

        function swiperCard() {
          if (window.innerWidth >= 768) {
            swiper = new Swiper('#company-cards-slider.swiper-container', {
              slidesPerView: 4,
              spaceBetween: 16,
              slidesPerGroup: 4,
              speed: 500,
              resizeReInit: true,
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              breakpoints: {
                991: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                  slidesPerGroup: 2,
                  speed: 500,
                },
                1499: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                  slidesPerGroup: 3,
                },
              },
            });

          } else {
            swiper = new Swiper('#company-cards-slider.swiper-container', {
              resizeReInit: true,
              slidesPerView: 1,
              spaceBetween: 16,
              slidesPerColumn: 2,
              slidesPerGroup: 1,
              speed: 500,
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });
          }
        }

        swiperCard();
        window.addEventListener('resize', swiperCard);

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_landing_life_sciences_v3: {
      init: function () {
        // JavaScript to be fired on all pages

        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var swiper;

        function swiperCard() {
          if (window.innerWidth >= 768) {
            swiper = new Swiper('#company-cards-slider.swiper-container', {
              slidesPerView: 4,
              spaceBetween: 16,
              slidesPerGroup: 4,
              speed: 500,
              resizeReInit: true,
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              breakpoints: {
                991: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                  slidesPerGroup: 2,
                  speed: 500,
                },
                1499: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                  slidesPerGroup: 3,
                },
              },
            });

          } else {
            swiper = new Swiper('#company-cards-slider.swiper-container', {
              resizeReInit: true,
              slidesPerView: 1,
              spaceBetween: 16,
              slidesPerColumn: 2,
              slidesPerGroup: 1,
              speed: 500,
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });
          }
        }

        swiperCard();
        window.addEventListener('resize', swiperCard);

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        function initCustomOpenClose() {
          jQuery('.routing-block-posts').customOpenClose({
            activeClass: 'active',
            items: '.post',
            opener: '.opener',
            closer: '.btn-close',
            slider: '.slide',
            animSpeed: 400
          });
        }

        initCustomOpenClose();
        
        // <a href="#" class="routing-tab-btn" data-target="item-2" data-post="biology">Active TAB 02 and open "biology"</a>
        $(document).on('click', '.routing-tab-btn', function (e) {
          e.preventDefault();
      
          var targetCode = $(this).data('target');
          var targetPost = $(this).data('post');
          var targetTab = $('.routing-component .routing-tabs-list li[data-code="' + targetCode + '"]');
      
          if (targetTab.length) {
              $('.routing-component .routing-tabs-list li').removeClass('active');
              targetTab.addClass('active');
      
              $('.routing-component .routing-tab-content-item').each(function () {
                  if ($(this).data('code') === targetCode) {
                      $(this).addClass('active');
      
                      if (targetPost) {
                          var blockPosts = $(this).find('.routing-block-posts');
                          var postToOpen = blockPosts.find('.post#' + targetPost);
      
                          if (postToOpen.length) {
                              blockPosts.find('.post.active').removeClass('active');
      
                              var opener = postToOpen.find('.opener');
                              if (opener.length) {
                                  opener.trigger('click');
                              }
      
                              var scrollTarget = $(window).width() < 1024 ? postToOpen : $('#routing-tabs-list-holder');
      
                              $('html, body').animate({
                                  scrollTop: scrollTarget.offset().top - 70
                              }, 100);
                          }
                      } else {
                          $('html, body').animate({
                              scrollTop: $('#routing-tabs-list-holder').offset().top - 70
                          }, 100);
                      }
                  } else {
                      $(this).removeClass('active');
                  }
              });
            }
        });

        //Tab Click
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.routing-component .routing-tabs-list-holder li.active');

          var hash = window.location.hash.substring(1);
          if (hash) {
            var targetTab = $('.routing-component .routing-tabs-list-holder li[data-code="' + hash + '"]');
            if (targetTab.length) {
              activateTab(targetTab);
            }
          }
        });

        $('.routing-component .routing-tabs-list-holder ul .routing-tabs-list-item').on('click', function (e) {
          var tab = $(this).parent();
          var isLinkClick = $(e.target).is('a') || $(e.target).closest('a').length > 0;
        
          if (isLinkClick && !tab.hasClass('active')) {
            e.preventDefault();
            return;
          }
        
          if (isLinkClick) {
            return;
          }
        
          e.preventDefault();
        
          var code = tab.data('code');
        
          if (!tab.hasClass('active')) {
            activateTab(tab);
            history.pushState(null, null, '#' + code);
          }
        });
        
        function activateTab(tab) {
          var code = tab[0].dataset.code;
          activeTab = tab;
          
          $('.routing-component .routing-tabs-list-holder li').removeClass('active');
          tab.addClass('active');

          $('.routing-component .routing-tab-content-item').each(function () {
            if ($(this)[0].dataset.code === code) {
              $(this).addClass('active');
            } else {
              $(this).removeClass('active');
            }
          });
        }

        $(window).on('hashchange', function () {
          var hash = window.location.hash.substring(1);
          if (hash) {
            var targetTab = $('.routing-component .routing-tabs-list-holder li[data-code="' + hash + '"]');
            if (targetTab.length) {
              activateTab(targetTab);
            }
          }
        });

      },
    },

    page_template_template_radiology: {
      init: function () {
        // JavaScript to be fired on all pages

        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.content-list-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.content-list-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.content-list-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_onboarding_page: {
      init: function () {
        // JavaScript to be fired on all pages
        if ($('.gt-faq-section')) {
          $('.faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.faq-openclose-holder').removeClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          if ($(this).hasClass('link-text-icon')) {
            return;
          }
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.content-list-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.content-list-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.content-list-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_algorithmic_tests: {
      init: function () {
        // JavaScript to be fired on all pages

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          if ($(this).hasClass('link-text-icon')) {
            return;
          }
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.content-list-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.content-list-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.content-list-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_order_test_v2: {
      init: function () {
        // JavaScript to be fired on all pages

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          if ($(this).hasClass('link-text-icon')) {
            return;
          }
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.content-list-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.content-list-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.content-list-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_landing_providers_pathology: {
      init: function () {
        // JavaScript to be fired on all pages

        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_landing_providers_oncology: {
      init: function () {
        // JavaScript to be fired on all pages

        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('.open-video').on('click', function (event) {
          event.preventDefault();

          $('.lightbox').fadeOut(0);
          var id = $(this).attr('href');
          $(id).fadeIn(0);

          return false;
        });

        $('.lightbox .close').on('click', function () {
          $('.lightbox').fadeOut(0);
          $('.page-overlay').hide();

          var vid = jQuery(this).closest('.lightbox').find('iframe[src*="youtube"]');
          if (vid.length > 0) {
            var src = vid.attr('src');
            vid.attr('src', '');
            vid.attr('src', src);
          }
        });
      },
    },

    page_template_template_genetic_test: {
      init: function () {
        // JavaScript to be fired on all pages
        if ($('.gt-faq-section')) {
          $('.faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.faq-openclose-holder').removeClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }

        const $quizSlider = $('#quiz-slider');
        const $lastSlide = $quizSlider.find('.swiper-slide:last').detach();
        var swiper = new Swiper($quizSlider, {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true,
          },
          fadeEffect: {
            crossFade: true,
          },
          /*navigation: {
            nextEl: ".button-next",
            prevEl: ".button-prev",
        },*/
        });
        var slidesAmount = $quizSlider.find('.swiper-slide').length;
        const $heroSection = $quizSlider.closest('.gt-hero-section');
        const $buyNowButton = $heroSection.find('.genetic-product-holder .buy-now');
        const $retakeQuizButton = $heroSection.find('.retake-button');

        function getQuizResults() {
          const params = $quizSlider.find('.swiper-slide').toArray().map(function (el) {
            return {
              name: $(el).attr('data-param-name'),
              value: $(el).attr('data-param-value'),
              numericValue: Number($(el).attr('data-param-numeric-value') || 0),
            };
          });
          const sum = params.reduce(function (acc, param) {
            return acc + param.numericValue;
          }, 0);
          const numericAnswersString = params.map(function (param) {
            return String(param.numericValue);
          }).join('');

          const queryStringBuilder = new URLSearchParams();
          params.forEach(function (param) {
            queryStringBuilder.append(param.name, param.value);
          });

          return {
            sum: sum,
            params: params,
            numericAnswersString: numericAnswersString,
            queryString: queryStringBuilder.toString(),
          };
        }

        $quizSlider.on('click', '.button-next input', function (e) {
          const $slide = $(this).closest('.swiper-slide');
          $slide.attr('data-param-numeric-value', $(this).val());
          $slide.attr('data-param-value', $(this).attr('data-value'));

          const quizResults = getQuizResults();

          if (swiper.activeIndex === 2 && quizResults.params[2].numericValue === 1) {
            swiper.appendSlide($lastSlide);
            slidesAmount++;
          }

          if (swiper.activeIndex < (slidesAmount - 1)) {
            swiper.slideNext();
            e.stopImmediatePropagation();
          } else {
            $heroSection.addClass(quizResults.sum > 0 ? 'eligible' : 'not-eligible');
            const href = [$buyNowButton.attr('data-base-url'), quizResults.queryString].join('?');
            $buyNowButton.attr('href', href);
          }
        });
        $retakeQuizButton.on('click', function () {
          $quizSlider.find('.button-next input').prop('checked', false);
          $heroSection.removeClass('eligible not-eligible');
          swiper.slideTo(0);
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_genetic_test_v3: {
      init: function () {
        // JavaScript to be fired on all pages
        if ($('.gt-faq-section')) {
          $('.faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.faq-openclose-holder').removeClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }

        var gt_hero_swiper = new Swiper('#gt-hero-carousel.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          noSwiping: true,
          noSwipingClass: 'swiper-slide',
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        const $quizSlider = $('#quiz-slider');
        var swiper = new Swiper($quizSlider, {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true,
          },
          fadeEffect: {
            crossFade: true,
          },
          /*navigation: {
              nextEl: ".button-next",
              prevEl: ".button-prev",
          },*/
        });
        var slidesAmount = $quizSlider.find('.swiper-slide').length;
        const $heroSection = $quizSlider.closest('.gt-hero-section');
        const $buyNowButton = $heroSection.find('.genetic-product-holder .buy-now');
        const $retakeQuizButton = $heroSection.find('.retake-button');
        const adminAjaxUrl = $heroSection.attr('data-admin-ajax-url');

        function getQuizResults() {
          const params = $quizSlider.find('.swiper-slide').toArray().map(function (el) {
            return {
              name: $(el).attr('data-param-name'),
              value: $(el).attr('data-param-value'),
              numericValue: Number($(el).attr('data-param-numeric-value') || 0),
            };
          });
          const sum = params.reduce(function (acc, param) {
            return acc + param.numericValue;
          }, 0);
          const numericAnswersString = params.map(function (param) {
            return String(param.numericValue);
          }).join('');

          const queryStringBuilder = new URLSearchParams();
          params.forEach(function (param) {
            queryStringBuilder.append(param.name, param.value);
          });

          return {
            sum: sum,
            params: params,
            numericAnswersString: numericAnswersString,
            queryString: queryStringBuilder.toString(),
          };
        }

        $quizSlider.on('click', '.button-next input', function (e) {
          const $slide = $(this).closest('.swiper-slide');
          $slide.attr('data-param-numeric-value', $(this).val());
          $slide.attr('data-param-value', $(this).attr('data-value'));

          const quizResults = getQuizResults();

          if (swiper.activeIndex < (slidesAmount - 1)) {
            swiper.slideNext();
            e.stopImmediatePropagation();
          } else {
            $heroSection.addClass(quizResults.sum > 0 ? 'eligible' : 'not-eligible');
            $.ajax({
              url: adminAjaxUrl,
              type: 'POST',
              data: [quizResults.queryString, 'action=jotform_submission'].join('&'),
            });
          }
        });
        $retakeQuizButton.on('click', function () {
          $quizSlider.find('.button-next input').prop('checked', false);
          $heroSection.removeClass('eligible not-eligible');
          swiper.slideTo(0);
        });
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_genetic_test_v3_Variant_C: {
      init: function () {
        // JavaScript to be fired on all pages
        if ($('.gt-faq-section')) {
          $('.faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.faq-openclose-holder').removeClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_multi_omics: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        $('.advantages-acc-opener').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.advantages-acc-opener').removeClass('open');
            $('.advantages-acc-opener').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click

        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.advantages-component .tabs-list li.active');
        });

        $('.advantages-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.advantages-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.advantages-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.advantages-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.advantages-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });

      },
    },

    page_template_template_dtc_lab_services: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_hereditary_cancer_testing: {
      init: function () {
        // JavaScript to be fired on all pages
        if ($('.gt-faq-section')) {
          $('.faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.faq-openclose-holder').removeClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_neuro_patients_v2: {
      init: function () {
        // JavaScript to be fired on all pages
        if ($('.gt-faq-section')) {
          $('.faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.faq-openclose-holder').removeClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_onco_patients_page: {
      init: function () {
        // JavaScript to be fired on all pages
        if ($('.gt-faq-section')) {
          $('.faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.faq-openclose-holder').removeClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_onco_patients_page_v2: {
      init: function () {
        // JavaScript to be fired on all pages
        if ($('.gt-faq-section')) {
          $('.faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.faq-openclose-holder').removeClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_subpage_publications: {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_subpage_publication_single: {
      init: function () {
        // JavaScript to be fired on all pages

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_subpage_webinars: {
      init: function () {
        // JavaScript to be fired on all pages

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_subpage_tempus: {
      init: function () {
        // JavaScript to be fired on all pages
        var amount_column = 2;
        var amount_logos = $('#logos-carousel.swiper-container .swiper-slide').length;

        if (amount_logos < 7) {
          amount_column = 1;
        }

        if (amount_logos < 12) {
          $('#logos-carousel.swiper-container').addClass('center-mode');
        }

        var logos_swiper = new Swiper('#logos-carousel.swiper-container', {
          // loop: true,
          runCallbacksOnInit: true,
          watchOverflow: true,
          slidesPerView: 6,
          slidesPerColumn: amount_column,
          spaceBetween: 0,
          noSwiping: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            // when window width is >= 768px
            767: {
              slidesPerView: 1,
              slidesPerColumn: 6,
              spaceBetween: 0,
            },
          },
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_subpage_press_releases: {
      init: function () {
        // JavaScript to be fired on all pages

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('.sub-nav-interaction-item').click(function () {
          $('.sub-nav-interaction-item').removeClass('active');
          this.classList.add('active');
        });

      },
    },

    page_template_template_subpage_media_coverage: {
      init: function () {
        // JavaScript to be fired on all pages

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('.sub-nav-interaction-item').click(function () {
          $('.sub-nav-interaction-item').removeClass('active');
          this.classList.add('active');
        });
      },
    },

    page_template_template_subpage_additional_partnerships: {
      init: function () {
        // JavaScript to be fired on all pages

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('.sub-nav-interaction-item').click(function () {
          $('.sub-nav-interaction-item').removeClass('active');
          this.classList.add('active');
        });
      },
    },

    page_template_template_subpage_blog: {
      init: function () {
        // JavaScript to be fired on all pages

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('.sub-nav-interaction-item').click(function () {
          $('.sub-nav-interaction-item').removeClass('active');
          this.classList.add('active');
        });
      },
    },

    page_template_template_subpage_emr_integration: {
      init: function () {
        // JavaScript to be fired on all pages

        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_checkout: {
      init: function () {
        // JavaScript to be fired on all pages
        
        $('.checkout-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          $(this).toggleClass('open');

          if ($(this).hasClass('open')) {
            $(this).next().slideDown();
          } else {
            $(this).next().slideUp();
          }

          return false;
        });
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_dermatology: {
      init: function () {

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.content-list-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.content-list-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.content-list-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_cardiology_v2: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click

        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.advantages-component .tabs-list li.active');
        });

        $('.advantages-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.advantages-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.advantages-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.advantages-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.advantages-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });

      },
    },

    page_template_template_tempus_io: {
      init: function () {
        // JavaScript to be fired on all pages
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.content-list-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.content-list-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.content-list-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_oncology_care_pathway_solution: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.content-list-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.content-list-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.content-list-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_responsible_disclosure: {

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.content-list-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.content-list-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.content-list-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_data_collaborations: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var swiper;

        function swiperCard() {
          if (window.innerWidth >= 768) {

            swiper = new Swiper('#company-cards-slider.swiper-container', {
              slidesPerView: 4,
              spaceBetween: 16,
              slidesPerGroup: 4,
              speed: 500,
              resizeReInit: true,
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              breakpoints: {
                991: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                  slidesPerGroup: 2,
                  speed: 500,
                },
                1499: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                  slidesPerGroup: 3,
                },
              },
            });

          } else {
            swiper = new Swiper('#company-cards-slider.swiper-container', {
              slidesPerView: 1,
              spaceBetween: 16,
              slidesPerColumn: 2,
              slidesPerGroup: 1,
              speed: 500,
              resizeReInit: true,
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });
          }
        }

        swiperCard();
        window.addEventListener('resize', swiperCard);
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_data_collaborations_v2: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var swiper;

        function swiperCard() {
          if (window.innerWidth >= 768) {

            swiper = new Swiper('#company-cards-slider.swiper-container', {
              slidesPerView: 4,
              spaceBetween: 16,
              slidesPerGroup: 4,
              speed: 500,
              resizeReInit: true,
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              breakpoints: {
                991: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                  slidesPerGroup: 2,
                  speed: 500,
                },
                1499: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                  slidesPerGroup: 3,
                },
              },
            });

          } else {
            swiper = new Swiper('#company-cards-slider.swiper-container', {
              slidesPerView: 1,
              spaceBetween: 16,
              slidesPerColumn: 2,
              slidesPerGroup: 1,
              speed: 500,
              resizeReInit: true,
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });
          }
        }

        swiperCard();
        window.addEventListener('resize', swiperCard);
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_life_sciences_phase: {
      init: function () {
        // JavaScript to be fired on all pages
        var cases_swiper = new Swiper('.use-cases-slider.swiper-container', {
          slidesPerView: 1,
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_events_library: {
      init: function () {
        const $list = $('.events-library-list');
        $list.on('click', '.chip-item', function (e) {
          const tagValue = $(this).attr('data-tag');
          const $filterSelect = $('.filter-holder [name=filter]');
          $filterSelect.val(tagValue).trigger('change');
          e.stopPropagation();
          return false;
        });
      },
    },
    post_template_single_event: {
      init: function () {

        var body_width = $('body').width();

        if (body_width < 1280) {
          if ($('.event-landing-body')) {
            $('.event-acc-list .event-acc-opener').click(function () {
              if ($(this).parent().hasClass('active')) {
                $('.event-acc-item').removeClass('active');
                $('.event-acc-item .event-acc-drop').slideUp();
              } else {
                $('.event-acc-item').removeClass('active');
                $(this).parent().addClass('active');
                $('.event-acc-item .event-acc-drop').slideUp();
                $(this).parent().find('.event-acc-drop').slideDown();
              }
              return false;
            });
          }

          if ($('.event-acc-drop')) {
            $('.event-acc-drop .event-acc-subitem>a').click(function () {
              if ($(this).parent().hasClass('active')) {
                $('.event-acc-drop .event-acc-subitem').removeClass('active');
                $('.event-acc-drop .event-acc-subitem .event-acc-subdrop').slideUp();
              } else {
                $('.event-acc-drop .event-acc-subitem').removeClass('active');
                $(this).parent().addClass('active');
                $('.event-acc-drop .event-acc-subitem .event-acc-subdrop').slideUp();
                $(this).parent().find('.event-acc-subdrop').slideDown();
              }
              return false;
            });
          }
        }
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_lilly_lung_program: {
      init: function () {
        // JavaScript to be fired on all pages
        if ($('.gt-faq-section.first-acc')) {

          $('.first-acc .faq-openclose-holder').addClass('active');
          $('.first-acc .faq-openclose-holder .faq-list').slideDown();

          $('.first-acc .faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.first-acc .faq-openclose-holder').removeClass('active');
              $('.first-acc .faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.first-acc .faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.first-acc .faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }
        ;

        if ($('.gt-faq-section.second-acc')) {

          $('.second-acc .faq-openclose-holder').addClass('active');
          $('.second-acc .faq-openclose-holder .faq-list').slideDown();

          $('.second-acc .faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.second-acc .faq-openclose-holder').removeClass('active');
              $('.second-acc .faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.second-acc .faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.second-acc .faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_rwd_page: {
      init: function () {
        // JavaScript to be fired on all pages
        $('.lightbox').each(function () {
          $(this).find('video').get(0).pause();
        });

        $('.open-video__watch').on('click', function (event) {
          event.preventDefault();
          var team = $(this).attr('href');

          $(team).fadeIn(0);
          $('body').addClass('open-lightbox full-video-section-lightbox');

          $('.lightbox').find('video').get(0).pause();

          if ($(team).find('video').length) {
            $(team).find('video').get(0).play();
          }
        });

        $('.lightbox .close-medium__watch').on('click', function () {
          $('body').removeClass('open-lightbox full-video-section-lightbox');
          $('.lightbox').fadeOut(0);
          $('.page-overlay').hide();
          var vid = jQuery(this).closest('.lightbox').find('iframe[src*="youtube"]');
          if (vid.length > 0) {
            var src = vid.attr('src');
            vid.attr('src', '');
            vid.attr('src', src);
          }

          $(this).closest('.lightbox').find('video').get(0).pause();

        });

        if ($('.gt-faq-section')) {

          $('.gt-faq-section .faq-openclose-holder').addClass('active');
          $('.gt-faq-section .faq-openclose-holder .faq-list').slideDown();

          $('.gt-faq-section .faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.gt-faq-section .faq-openclose-holder').removeClass('active');
              $('.gt-faq-section .faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.gt-faq-section .faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.gt-faq-section .faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }
        ;
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_clinical_trials: {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('.toggle-opener').on('click', function (e) {
          e.preventDefault();
          $(this).toggleClass('open');
          if ($(this).hasClass('open')) {
            $(this).next().slideDown();
          } else {
            $(this).next().slideUp();
          }

          return false;
        });
      },
    },

    page_template_template_genomic_profiling_page: {
      init: function () {
        // JavaScript to be fired on all pages
        $('.advantages-acc-opener').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.advantages-acc-opener').removeClass('open');
            $('.advantages-acc-opener').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

        var init = false;
        var swiper;

        function swiperCard() {
          if (window.innerWidth >= 768) {
            if (!init) {
              init = true;
              swiper = new Swiper('#smart-reporting-slider.swiper-container', {
                slidesPerView: 1,
                effect: 'fade',
                spaceBetween: 0,
                autoHeight: true,
                watchOverflow: true,
                loop: true,
                allowTouchMove: false,
                pagination: {
                  el: '.smart-swiper-pagination',
                  clickable: true,
                },
                navigation: {
                  nextEl: '.next-btn',
                },
                fadeEffect: {
                  crossFade: true,
                },
              });
            }
          } else if (init) {
            swiper.destroy();
            init = false;
          }
        }

        swiperCard();
        window.addEventListener('resize', swiperCard);

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.advantages-component .tabs-list li.active');
        });

        $('.advantages-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.advantages-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.advantages-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.advantages-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.advantages-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_cardiology_care_gap_solutions: {
      init: function () {
        // JavaScript to be fired on all pages
        $('.advantages-acc-opener').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.advantages-acc-opener').removeClass('open');
            $('.advantages-acc-opener').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.advantages-component .tabs-list li.active');
        });

        $('.advantages-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.advantages-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.advantages-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.advantages-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.advantages-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_genomic_test: {
      init: function () {
        // JavaScript to be fired on all pages

        var string = location.href;
        var convertedString = string.toLowerCase();

        if ((convertedString.indexOf('optional-tests') != -1) && ($(window).width() > 991)) {
          $('.tabs-list ul li').removeClass('active');
          $('.tabs-list ul li:nth-child(4)').addClass('active');
          $('.advantages-component .item').removeClass('active');
          $('.advantages-component .item:nth-child(4)').addClass('active');

          $('html, body').animate({
            scrollTop: $('#advantages-component').offset().top,
          }, 'slow');
        }

        $('.advantages-acc-opener').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.advantages-acc-opener').removeClass('open');
            $('.advantages-acc-opener').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

        $('.gemomic-table-acc-opener').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.gemomic-table-acc-opener').removeClass('open');
            $('.gemomic-table-acc-opener').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.advantages-component .tabs-list li.active');
        });

        $('.advantages-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.advantages-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.advantages-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.advantages-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.advantages-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_xm_webpage: {
      init: function () {
        // JavaScript to be fired on all pages

        $('.advantages-acc-opener').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.advantages-acc-opener').removeClass('open');
            $('.advantages-acc-opener').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        //Tab Click
        var tabIndex = 0;
        var activeTab01;
        var activeTab02;

        $(window).on('load', function () {
          activeTab01 = $('.advantages-component-01 .tabs-list li.active');
          activeTab02 = $('.advantages-component-02 .tabs-list li.active');
        });

        $('.advantages-component-01 .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab01 = tab;
              $('.advantages-component-01 .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.advantages-component-01 .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.advantages-component-01 .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.advantages-component-01 .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });

        $('.advantages-component-02 .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab02 = tab;
              $('.advantages-component-02 .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.advantages-component-02 .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.advantages-component-02 .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.advantages-component-02 .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_life_sciences_xt_cdx_page: {
      init: function () {
        // JavaScript to be fired on all pages

        $('.gemomic-table-acc-opener').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.gemomic-table-acc-opener').removeClass('open');
            $('.gemomic-table-acc-opener').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_template_tempus_lens: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var vid = jQuery('.lightbox').find('iframe[src*="uploads"]');
        var src = vid.attr('src');
        vid.attr('src', '');

        $('.open-video').click(function () {
          if (vid.length > 0) {
            vid.attr('src', src);
          }
        });

        $('.lightbox .close').on('click', function () {
          $('.lightbox').fadeOut(0);
          $('.page-overlay').hide();
          if (vid.length > 0) {
            vid.attr('src', '');
          }
        });

        $('.lets-talk-button').on('click', function (e) {
          e.preventDefault();
          zE.activate();
        });
        $('#chat a.link-text-icon').on('click', function (e) {
          e.preventDefault();
          zE.activate();
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_tempus_lens_v2: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        $('.lets-talk-button').on('click', function (e) {
          e.preventDefault();
          zE.activate();
        });
        $('#chat a.link-text-icon').on('click', function (e) {
          e.preventDefault();
          zE.activate();
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_notetaker: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        if ($('.gt-faq-section')) {

          $('.faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.faq-openclose-holder').removeClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }

        if (window.innerWidth < 768) {
          if ($('.pricing-cards-list').length) {
            $('.header-card').click(function () {
              let $parent = $(this).parent();
              
              if ($parent.hasClass('active')) {
                $parent.removeClass('active').find('.slide-card').slideUp();
              } else {
                $('.holder-card.active').removeClass('active').find('.slide-card').slideUp();
                $parent.addClass('active').find('.slide-card').slideDown(function () {
                  $('html, body').animate({
                    scrollTop: $parent.offset().top - 70
                  }, 200);
                });
              }
              
              return false;
            });
          }
        }               

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_notetaker_support: {
      init: function () {
        // JavaScript to be fired on all pages

        if ($('.gt-faq-section')) {

          $('.faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.faq-openclose-holder').removeClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }           

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_job_postings_page: {
      init: function () {
        // JavaScript to be fired on all pages

        function initCheckboxesDropdown(checkboxes, dropSelectBox) {
          var show = true;

          $(dropSelectBox).on('click', function (event) {
            showCheckboxes();
          });

          function showCheckboxes() {
            if (show) {
              checkboxes.style.display = 'block';
              show = false;
              $(dropSelectBox).addClass('active');
            } else {
              checkboxes.style.display = 'none';
              show = true;
              $(dropSelectBox).removeClass('active');
            }

            window.addEventListener('click', function (e) {
              if (!checkboxes.contains(e.target) && !dropSelectBox.contains(e.target)) {
                checkboxes.style.display = 'none';
                show = true;
                $(dropSelectBox).removeClass('active');
              }
            });
          }
        }

        initCheckboxesDropdown($('#departmentsCheckBoxes')[0], $('#departmentsDropSelectBox')[0]);
        initCheckboxesDropdown($('#locationsCheckBoxes')[0], $('#locationsDropSelectBox')[0]);

        const $form = $('.filter-holder');
        const $filterText = $form.find('[name=filter]');
        const $selectAllLocationsCheckbox = $form.find('[data-location-id=""] input');
        const $selectAllDepartmentsCheckbox = $form.find('[data-department-id=""] input');
        const $filterRemote = $form.find('.remote-friendly');
        const $resetFilterButton = $form.find('.reset-all-btn');

        const $container = $('.job-posting-section .default-container [data-remote-location-id]');
        const $positions = $container.find('.job-list-content li');
        const allDepartmentIds = [];
        const allLocationIds = [];
        const allLocationsMap = new Map();

        const remoteLocationId = $container.attr('data-remote-location-id');

        $form.find('[data-location-id]').each(function () {
          const name = $(this).text().toLowerCase();
          const locationId = $(this).attr('data-location-id');
          if (locationId) {
            allLocationIds.push(locationId);
            allLocationsMap.set(locationId, name);
          }
        });

        $positions.each(function () {
          const locationIds = $(this).attr('data-location-ids').split(',').filter(function (id) {
            return id !== '';
          });
          const locationIdsSet = new Set(locationIds);
          $(this).data('locationIdsSet', locationIdsSet);

          //update free text search by adding locations
          const text = $(this).attr('data-text');
          const locationNames = locationIds.map(function (id) {
            return allLocationsMap.get(id);
          });
          $(this).attr('data-text', [text, locationNames.join(' ')].join(' '));
        });

        $form.find('[data-department-id]').each(function () {
          const departmentId = $(this).attr('data-department-id');
          if (departmentId) {
            allDepartmentIds.push(departmentId);
          }
        });

        function performFiltering(text, departmentIds, locationIds, remoteFriendly) {
          const departmentIdsSet = new Set(departmentIds);
          $positions.detach();
          $container.find('.job-list-content').remove();
          if (
            text ||
            (departmentIds.length > 0 && departmentIds.length < allDepartmentIds.length) ||
            (locationIds.length > 0 && locationIds.length < allLocationIds.length) ||
            remoteFriendly
          ) {
            const $ul = $('<ul class="job-list-content" />');
            $ul.append(
              $positions.filter(function () {
                var result = true;
                if (text) {
                  result = result && $(this).attr('data-text').includes(text);
                }
                if (departmentIds.length) {
                  result = result && departmentIdsSet.has($(this).attr('data-department-id'));
                }
                if (locationIds.length) {
                  const locationIdsSet = $(this).data('locationIdsSet');
                  result = result && locationIds.some(function (locationId) {
                    return locationIdsSet.has(locationId);
                  });
                }
                if (remoteFriendly) {
                  const locationIdsSet = $(this).data('locationIdsSet');
                  result = result && locationIdsSet.has(remoteLocationId);
                }
                return result;
              }),
            );
            $container.append($ul);
          } else {
            var positionsGroup = [];
            var lastDepartmentId = null;

            $positions.each(function () {
              const departmentId = $(this).attr('data-department-id');
              if (lastDepartmentId !== null && lastDepartmentId !== departmentId) {
                const $ul = $('<ul class="job-list-content" />');
                $ul.append(positionsGroup);
                $container.append($ul);
                positionsGroup = [];
              }
              lastDepartmentId = departmentId;
              positionsGroup.push(this);
            });
            const $ul = $('<ul class="job-list-content" />');
            $ul.append(positionsGroup);
            $container.append($ul);
          }
        }

        $filterText.on('input', function () {
          $form.submit();
        });
        $filterRemote.on('change', function () {
          $form.submit();
        });

        $form.find('[data-department-id]').on('change', function (e) {
          var selectedDepartmentIds = [];
          const checked = $(this).find('input').prop('checked');
          const departmentId = $(this).attr('data-department-id');
          if (departmentId === '') {
            selectedDepartmentIds = allDepartmentIds.slice();
            $form.find('[data-department-id] input').prop('checked', checked);
          } else {
            $form.find('[data-department-id!=""]').each(function () {
              if ($(this).find('input').prop('checked')) {
                selectedDepartmentIds.push($(this).attr('data-department-id'));
              }
            });
            $selectAllDepartmentsCheckbox.prop('checked', selectedDepartmentIds.length === allDepartmentIds.length);
          }
          $form.submit();
        });
        $form.find('[data-location-id]').on('change', function (e) {
          var selectedLocationIds = [];
          const checked = $(this).find('input').prop('checked');
          const locationId = $(this).attr('data-location-id');
          if (locationId === '') {
            selectedLocationIds = allLocationIds.slice();
            $form.find('[data-location-id] input').prop('checked', checked);
          } else {
            $form.find('[data-location-id!=""]').each(function () {
              if ($(this).find('input').prop('checked')) {
                selectedLocationIds.push($(this).attr('data-location-id'));
              }
            });
            $selectAllLocationsCheckbox.prop('checked', selectedLocationIds.length === allLocationIds.length);
          }
          $form.submit();
        });

        $resetFilterButton.on('click', function () {
          $filterText.val('');
          $form.find('[data-department-id] input').prop('checked', true);
          $form.find('[data-location-id] input').prop('checked', true);
          $filterRemote.find('input').prop('checked', false);
          $form.submit();
          return false;
        });
        $form.on('submit', function (e) {
          const filterTextOriginal = $filterText.val();

          const selectedDepartmentIds = [];
          const isRemoteFriendlyOn = $filterRemote.find('input').is(':checked');
          $form.find('[data-department-id] input:checked').each(function () {
            const departmentId = $(this).parent().attr('data-department-id');
            if (departmentId) {
              selectedDepartmentIds.push(departmentId);
            }
          });

          const selectedLocationIds = [];
          $form.find('[data-location-id] input:checked').each(function () {
            const locationId = $(this).parent().attr('data-location-id');
            if (locationId) {
              selectedLocationIds.push(locationId);
            }
          });
          performFiltering(filterTextOriginal.trim().toLowerCase(), selectedDepartmentIds, selectedLocationIds,
            isRemoteFriendlyOn);

          const url = new URL(window.location);
          url.searchParams.set('department',
            selectedDepartmentIds.length === allDepartmentIds.length ? '' : selectedDepartmentIds.join(','));
          url.searchParams.set('location',
            selectedLocationIds.length === allLocationIds.length ? '' : selectedLocationIds.join(','));
          url.searchParams.set('filter', $filterText.val());
          url.searchParams.set('remoteFriendly', isRemoteFriendlyOn ? 1 : 0);
          window.history.replaceState({
            departmentIds: selectedDepartmentIds,
            locationId: selectedLocationIds,
            filterText: filterTextOriginal,
            remoteFriendly: isRemoteFriendlyOn,
          }, '', url.toString());
          return false;
        });

        $container.on('click', '.department-holder', function () {
          const departmentId = $(this).closest('li').attr('data-department-id');
          $form.find('[data-department-id] input').prop('checked', false);
          //triggering change event to force location list recalculation
          $form.find('[data-department-id="' + departmentId + '"] input').prop('checked', true).trigger('change');
        });
        $container.on('click', '.location-holder [data-location-id]', function () {
          const locationId = $(this).attr('data-location-id');
          $form.find('[data-location-id] input').prop('checked', false);
          //triggering change event to force location list recalculation
          $form.find('[data-location-id="' + locationId + '"] input').prop('checked', true).trigger('change');
        });
        $container.on('click', '.remote-holder', function () {
          $filterRemote.find('input').prop('checked', true).trigger('change');
        });

        //get current filter from url
        function initFilterFromUrl() {
          const url = new URL(window.location);
          const selectedDepartmentIds = (url.searchParams.get('department') || '').split(',').
            filter(function (departmentId) {
              return departmentId;
            });
          const selectedLocationIds = (url.searchParams.get('location') || '').split(',').filter(function (locationId) {
            return locationId;
          });
          const filterText = url.searchParams.get('filter');
          const isRemoteFriendlyOn = url.searchParams.get('remoteFriendly') === '1';

          //init departments
          $form.find('[data-department-id] input').
            prop('checked',
              selectedDepartmentIds.length === 0 || selectedDepartmentIds.length === allDepartmentIds.length);
          selectedDepartmentIds.forEach(function (departmentId) {
            if (departmentId) {
              $form.find('[data-department-id="' + departmentId + '"] input').prop('checked', true);
            }
          });
          if (selectedDepartmentIds.length > 0 && $form.find('[data-department-id] input:checked').length ===
            allDepartmentIds.length) {
            $selectAllDepartmentsCheckbox.prop('checked', selectedDepartmentIds.length === allDepartmentIds.length);
          }
          //init locationns
          $form.find('[data-location-id] input').
            prop('checked', selectedLocationIds.length === 0 || selectedLocationIds.length === allLocationIds.length);
          selectedLocationIds.forEach(function (locationId) {
            if (locationId) {
              $form.find('[data-location-id="' + locationId + '"] input').prop('checked', true);
            }
          });
          if (selectedLocationIds.length > 0 && $form.find('[data-location-id] input:checked').length ===
            allLocationIds.length) {
            $selectAllLocationsCheckbox.prop('checked', selectedLocationIds.length === allLocationIds.length);
          }

          //init filter text
          $filterText.val(filterText);
          //init remote-friendly checkbox
          $filterRemote.find('input').prop('checked', isRemoteFriendlyOn);
          $form.submit();
        }

        initFilterFromUrl();
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_compass: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#quote-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_pit_page: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#pit-hero-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          loop: true,
          pagination: {
            el: '.hero-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var quote_swiper = new Swiper('#pit-reviews-slider.swiper-container', {
          spaceBetween: 0,
          slidesPerView: 4,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.reviews-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            767: {
              slidesPerView: 1,
              autoHeight: false,
            },
            1023: {
              slidesPerView: 2,
            },
          },
        });

        $('.hero-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.hero-accordion-toogle').removeClass('open');
            $('.hero-accordion-slide').slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

        $('.faq-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          $(this).toggleClass('open');

          if ($(this).hasClass('open')) {
            $(this).next().slideDown();
          } else {
            $(this).next().slideUp();
          }

          return false;
        });
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_labs_page: {
      init: function () {
        // JavaScript to be fired on all pages

        $('.locations-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.locations-accordion-toogle').removeClass('open');
            $('.locations-accordion-slide').slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

        $('.locations-accordion .locations-accordion-item .locations-accordion-toogle').on('click', function(event) {
          event.preventDefault();

          var parentItem = $(this).closest('.locations-accordion-item');

          var index = parentItem.index();

          $('.locations-map-holder').removeClass(function(index, className) {
              return (className.match(/(^|\s)map-item-\S+/g) || []).join(' ');
          });

          $('.locations-map-holder').addClass('map-item-' + index);
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_pit_page_e2: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#pit-hero-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          loop: true,
          pagination: {
            el: '.hero-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var quote_swiper = new Swiper('#pit-reviews-slider.swiper-container', {
          spaceBetween: 0,
          slidesPerView: 4,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.reviews-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            767: {
              slidesPerView: 1,
              autoHeight: false,
            },
            1023: {
              slidesPerView: 2,
            },
          },
        });

        $('.hero-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.hero-accordion-toogle').removeClass('open');
            $('.hero-accordion-slide').slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

        $('.faq-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          $(this).toggleClass('open');

          if ($(this).hasClass('open')) {
            $(this).next().slideDown();
          } else {
            $(this).next().slideUp();
          }

          return false;
        });

        const $quizSlider = $('#quiz-slider');
        var swiper = new Swiper($quizSlider, {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          watchOverflow: true,
          simulateTouch: false,
          oneWayMovement: true,
          allowTouchMove: false,
          pagination: {
            el: '.pit-quiz-holder .swiper-pagination',
            clickable: true,
            dynamicBullets: true,
          },
          fadeEffect: {
            crossFade: true,
          },
          /*navigation: {
              nextEl: ".button-next",
              prevEl: ".button-prev",
          },*/
        });
        var slidesAmount = $quizSlider.find('.swiper-slide').length;
        const $heroSection = $quizSlider.closest('.description-holder');
        const $retakeQuizButton = $heroSection.find('.retake-button-blue');
        const adminAjaxUrl = $heroSection.attr('data-admin-ajax-url');

        function getQuizResults() {
          const params = $quizSlider.find('.swiper-slide').toArray().map(function (el) {
            return {
              name: $(el).attr('data-param-name'),
              value: $(el).attr('data-param-value'),
              numericValue: Number($(el).attr('data-param-numeric-value') || 0),
            };
          });
          const sum = params.reduce(function (acc, param) {
            return acc + param.numericValue;
          }, 0);
          const numericAnswersString = params.map(function (param) {
            return String(param.numericValue);
          }).join('');

          const queryStringBuilder = new URLSearchParams();
          params.forEach(function (param) {
            queryStringBuilder.append(param.name, param.value);
          });

          return {
            sum: sum,
            params: params,
            numericAnswersString: numericAnswersString,
            queryString: queryStringBuilder.toString(),
          };
        }

        $quizSlider.on('click', '.button-next input', function (e) {
          const $slide = $(this).closest('.swiper-slide');
          $slide.attr('data-param-numeric-value', $(this).val());
          $slide.attr('data-param-value', $(this).attr('data-value'));

          const quizResults = getQuizResults();

          if (swiper.activeIndex < (slidesAmount - 1)) {
            swiper.slideNext();
            e.stopImmediatePropagation();
          } else {
            $heroSection.addClass(quizResults.sum > 0 ? 'eligible' : 'not-eligible');
            // $.ajax({
            //   url: adminAjaxUrl,
            //   type: 'POST',
            //   data: [quizResults.queryString, 'action=jotform_submission'].join('&')
            // });
          }
        });
        $retakeQuizButton.on('click', function () {
          $quizSlider.find('.button-next input').prop('checked', false);
          $heroSection.removeClass('eligible not-eligible');
          swiper.slideTo(0);
        });
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_pit_page_e3: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#pit-hero-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          loop: true,
          pagination: {
            el: '.hero-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var quote_swiper = new Swiper('#pit-reviews-slider.swiper-container', {
          spaceBetween: 0,
          slidesPerView: 4,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.reviews-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            767: {
              slidesPerView: 1,
              autoHeight: false,
            },
            1023: {
              slidesPerView: 2,
            },
          },
        });

        $('.hero-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.hero-accordion-toogle').removeClass('open');
            $('.hero-accordion-slide').slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

        $('.faq-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          $(this).toggleClass('open');

          if ($(this).hasClass('open')) {
            $(this).next().slideDown();
          } else {
            $(this).next().slideUp();
          }

          return false;
        });

        const $quizSlider = $('#quiz-slider');
        var swiper = new Swiper($quizSlider, {
          slidesPerView: 1,
          effect: 'fade',
          autoHeight: true,
          spaceBetween: 0,
          watchOverflow: true,
          simulateTouch: false,
          oneWayMovement: true,
          allowTouchMove: false,
          pagination: {
            el: '.pit-quiz-holder .swiper-pagination',
            clickable: true,
            dynamicBullets: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });
        var slidesAmount = $quizSlider.find('.swiper-slide').length;
        const $heroSection = $quizSlider.closest('.description-holder');
        const $retakeQuizButton = $heroSection.find('.retake-button-blue');
        const adminAjaxUrl = $heroSection.attr('data-admin-ajax-url');

        function getQuizResults() {
          const params = $quizSlider.find('.swiper-slide').toArray().map(function (el) {
            return {
              name: $(el).attr('data-param-name'),
              value: $(el).attr('data-param-value'),
              numericValue: Number($(el).attr('data-param-numeric-value') || 0),
            };
          });
          const sum = params.reduce(function (acc, param) {
            return acc + param.numericValue;
          }, 0);
          const numericAnswersString = params.map(function (param) {
            return String(param.numericValue);
          }).join('');

          const queryStringBuilder = new URLSearchParams();
          params.forEach(function (param) {
            queryStringBuilder.append(param.name, param.value);
          });

          return {
            sum: sum,
            params: params,
            numericAnswersString: numericAnswersString,
            queryString: queryStringBuilder.toString(),
          };
        }

        $quizSlider.on('click', '.button-final, .button-next input', function (e) {
          const $slide = $(this).closest('.swiper-slide');
          $slide.attr('data-param-numeric-value', $(this).attr('value'));
          $slide.attr('data-param-value', $(this).attr('data-value'));

          const quizResults = getQuizResults();

          if (swiper.activeIndex < (slidesAmount - 1)) {
            swiper.slideNext();
            e.stopImmediatePropagation();
          } else {
            $heroSection.addClass(quizResults.sum > 0 ? 'eligible' : 'not-eligible');
            // $.ajax({
            //   url: adminAjaxUrl,
            //   type: 'POST',
            //   data: [quizResults.queryString, 'action=jotform_submission'].join('&')
            // });
          }
        });
        $retakeQuizButton.on('click', function () {
          $quizSlider.find('.button-next input').prop('checked', false);
          $heroSection.removeClass('eligible not-eligible');
          swiper.slideTo(0);
        });
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_genetic_test_g_a: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#pit-hero-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          loop: true,
          pagination: {
            el: '.hero-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var quote_swiper = new Swiper('#pit-reviews-slider.swiper-container', {
          spaceBetween: 0,
          slidesPerView: 4,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.reviews-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            767: {
              slidesPerView: 1,
              autoHeight: false,
            },
            1023: {
              slidesPerView: 2,
            },
          },
        });

        $('.hero-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.hero-accordion-toogle').removeClass('open');
            $('.hero-accordion-slide').slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

        $('.faq-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          $(this).toggleClass('open');

          if ($(this).hasClass('open')) {
            $(this).next().slideDown();
          } else {
            $(this).next().slideUp();
          }

          return false;
        });

        const $quizSlider = $('#quiz-slider');
        var swiper = new Swiper($quizSlider, {
          slidesPerView: 1,
          effect: 'fade',
          autoHeight: true,
          spaceBetween: 0,
          watchOverflow: true,
          simulateTouch: false,
          oneWayMovement: true,
          allowTouchMove: false,
          pagination: {
            el: '.pit-quiz-holder .swiper-pagination',
            clickable: true,
            dynamicBullets: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });
        var slidesAmount = $quizSlider.find('.swiper-slide').length;
        const $heroSection = $quizSlider.closest('.description-holder');
        const $retakeQuizButton = $heroSection.find('.retake-button-blue');
        const adminAjaxUrl = $heroSection.attr('data-admin-ajax-url');

        function getQuizResults() {
          const params = $quizSlider.find('.swiper-slide').toArray().map(function (el) {
            return {
              name: $(el).attr('data-param-name'),
              value: $(el).attr('data-param-value'),
              numericValue: Number($(el).attr('data-param-numeric-value') || 0),
            };
          });
          const sum = params.reduce(function (acc, param) {
            return acc + param.numericValue;
          }, 0);
          const numericAnswersString = params.map(function (param) {
            return String(param.numericValue);
          }).join('');

          const queryStringBuilder = new URLSearchParams();
          params.forEach(function (param) {
            queryStringBuilder.append(param.name, param.value);
          });

          return {
            sum: sum,
            params: params,
            numericAnswersString: numericAnswersString,
            queryString: queryStringBuilder.toString(),
          };
        }

        $quizSlider.on('click', '.button-final, .button-next input', function (e) {
          const $slide = $(this).closest('.swiper-slide');
          $slide.attr('data-param-numeric-value', $(this).attr('value'));
          $slide.attr('data-param-value', $(this).attr('data-value'));

          const quizResults = getQuizResults();

          if (swiper.activeIndex < (slidesAmount - 1)) {
            swiper.slideNext();
            e.stopImmediatePropagation();
          } else {
            $heroSection.addClass(quizResults.sum > 0 ? 'eligible' : 'not-eligible');
            // $.ajax({
            //   url: adminAjaxUrl,
            //   type: 'POST',
            //   data: [quizResults.queryString, 'action=jotform_submission'].join('&')
            // });
          }
        });
        $retakeQuizButton.on('click', function () {
          $quizSlider.find('.button-next input').prop('checked', false);
          $heroSection.removeClass('eligible not-eligible');
          swiper.slideTo(0);
        });

        //donut chart animation
        const $donutChartMaskCircle = $('#donutChartMaskCircle');
        if ($donutChartMaskCircle) {
          const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                $donutChartMaskCircle.addClass('animate');
              }
            });
          }, {
            threshold: 1.0,
          });
          var svgDonut = $donutChartMaskCircle.closest('svg')[0];
          if (svgDonut) {
              observer.observe(svgDonut);
          } else {
              console.error('Donut svg not found');
          }
        }
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_genetic_test_k_a: {
      init: function () {
        // JavaScript to be fired on all pages
        initAutoComplete();
        var quote_swiper = new Swiper('#pit-hero-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          loop: true,
          pagination: {
            el: '.hero-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var quote_swiper = new Swiper('#pit-reviews-slider.swiper-container', {
          spaceBetween: 0,
          slidesPerView: 4,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.reviews-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            767: {
              slidesPerView: 1,
              autoHeight: false,
            },
            1023: {
              slidesPerView: 2,
            },
          },
        });

        $('.hero-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.hero-accordion-toogle').removeClass('open');
            $('.hero-accordion-slide').slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

        $('.faq-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          $(this).toggleClass('open');

          if ($(this).hasClass('open')) {
            $(this).next().slideDown();
          } else {
            $(this).next().slideUp();
          }

          return false;
        });

        //donut chart animation
        const $donutChartMaskCircle = $('#donutChartMaskCircle');
        if ($donutChartMaskCircle) {
          const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                $donutChartMaskCircle.addClass('animate');
              }
            });
          }, {
            threshold: 1.0,
          });
          var svgDonut = $donutChartMaskCircle.closest('svg')[0];
          if (svgDonut) {
              observer.observe(svgDonut);
          } else {
              console.error('Donut svg not found');
          }
        }
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_genetic_test_h_a: {
      init: function () {
        // JavaScript to be fired on all pages
        var quote_swiper = new Swiper('#pit-hero-slider.swiper-container', {
          slidesPerView: 1,
          effect: 'fade',
          spaceBetween: 0,
          autoHeight: true,
          watchOverflow: true,
          loop: true,
          pagination: {
            el: '.hero-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
          },
          fadeEffect: {
            crossFade: true,
          },
        });

        var quote_swiper = new Swiper('#pit-reviews-slider.swiper-container', {
          spaceBetween: 0,
          slidesPerView: 4,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.reviews-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            767: {
              slidesPerView: 1,
              autoHeight: false,
            },
            1023: {
              slidesPerView: 2,
            },
          },
        });

        $('.hero-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.hero-accordion-toogle').removeClass('open');
            $('.hero-accordion-slide').slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

        $('.faq-accordion-toogle').on('click', function (e) {
          e.preventDefault();

          $(this).toggleClass('open');

          if ($(this).hasClass('open')) {
            $(this).next().slideDown();
          } else {
            $(this).next().slideUp();
          }

          return false;
        });

        const $quizSlider = $('#quiz-slider');
        var swiper = new Swiper($quizSlider, {
          slidesPerView: 1,
          effect: 'fade',
          autoHeight: true,
          spaceBetween: 0,
          watchOverflow: true,
          simulateTouch: false,
          oneWayMovement: true,
          allowTouchMove: false,
          pagination: {
            el: '.pit-quiz-holder .swiper-pagination',
            clickable: true,
            dynamicBullets: true,
          },
          fadeEffect: {
            crossFade: true,
          },
        });
        var slidesAmount = $quizSlider.find('.swiper-slide').length;
        const $heroSection = $quizSlider.closest('.description-holder');
        const $retakeQuizButton = $heroSection.find('.retake-button-blue');
        const adminAjaxUrl = $heroSection.attr('data-admin-ajax-url');

        function getQuizResults() {
          const params = $quizSlider.find('.swiper-slide').toArray().map(function (el) {
            return {
              name: $(el).attr('data-param-name'),
              value: $(el).attr('data-param-value'),
              numericValue: Number($(el).attr('data-param-numeric-value') || 0),
            };
          });
          const sum = params.reduce(function (acc, param) {
            return acc + param.numericValue;
          }, 0);
          const numericAnswersString = params.map(function (param) {
            return String(param.numericValue);
          }).join('');

          const queryStringBuilder = new URLSearchParams();
          params.forEach(function (param) {
            queryStringBuilder.append(param.name, param.value);
          });

          return {
            sum: sum,
            params: params,
            numericAnswersString: numericAnswersString,
            queryString: queryStringBuilder.toString(),
          };
        }

        $quizSlider.on('click', '.button-final, .button-next input', function (e) {
          const $slide = $(this).closest('.swiper-slide');
          $slide.attr('data-param-numeric-value', $(this).attr('value'));
          $slide.attr('data-param-value', $(this).attr('data-value'));

          const quizResults = getQuizResults();

          if (swiper.activeIndex < (slidesAmount - 1)) {
            swiper.slideNext();
            e.stopImmediatePropagation();
          } else {
            $heroSection.addClass(quizResults.sum > 0 ? 'eligible' : 'not-eligible');
            // $.ajax({
            //   url: adminAjaxUrl,
            //   type: 'POST',
            //   data: [quizResults.queryString, 'action=jotform_submission'].join('&')
            // });
          }
        });
        $retakeQuizButton.on('click', function () {
          $quizSlider.find('.button-next input').prop('checked', false);
          $heroSection.removeClass('eligible not-eligible');
          swiper.slideTo(0);
        });

        //donut chart animation
        const $donutChartMaskCircle = $('#donutChartMaskCircle');
        if ($donutChartMaskCircle) {
          const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                $donutChartMaskCircle.addClass('animate');
              }
            });
          }, {
            threshold: 1.0,
          });
          var svgDonut = $donutChartMaskCircle.closest('svg')[0];
          if (svgDonut) {
              observer.observe(svgDonut);
          } else {
              console.error('Donut svg not found');
          }
        }
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_tempus_pro: {
      init: function () {
        // JavaScript to be fired on all pages
        if ($('.gt-faq-section')) {

          $('.faq-openclose-holder').addClass('active');
          $('.faq-openclose-holder .faq-list').slideDown();

          $('.faq-openclose-holder .faq-opener-title').click(function () {
            if ($(this).parent().hasClass('active')) {
              $('.faq-openclose-holder').removeClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
            } else {
              $('.faq-openclose-holder').removeClass('active');
              $(this).parent().addClass('active');
              $('.faq-openclose-holder .faq-list').slideUp();
              $(this).parent().find('.faq-list').slideDown();
            }
            return false;
          });
        }

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_cdx_page_v2: {
      init: function () {
        // JavaScript to be fired on all pages
        $('.content-list-component.cdx-page .tabs-list .title').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.content-list-component.cdx-page .tabs-list .title').removeClass('open');
            $('.content-list-component.cdx-page .tabs-list .title').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var component = $(this).parent().closest('.content-list-component');
          var component_items = component.find('div.item');
          var tabholder = $(this).parent().parent();
          var tabholder_items = tabholder.children('li');
          var code = tab[0].dataset.code;

          if ($(window).width() > 767) {
            if (!tab.hasClass('active')) {
              activeTab = tab;
              tabholder_items.removeClass('active');
              tab.addClass('active');

              component_items.each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            // tab.toggleClass("active");
            // tab.each(function () {
            //     if ($(this).hasClass("active")) {
            //         $(this).children(".mobile-item").addClass("active");
            //     } else {
            //         $(this).children(".mobile-item").removeClass("active");
            //     }
            // })
          }
        });
      },
    },

    page_template_template_ecg_ai: {
      init: function () {
        // JavaScript to be fired on all pages
        $('.content-list-component.mobile-accordion .tabs-list .title').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.content-list-component.mobile-accordion .tabs-list .title').removeClass('open');
            $('.content-list-component.mobile-accordion .tabs-list .title').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var component = $(this).parent().closest('.content-list-component');
          var component_items = component.find('div.item');
          var tabholder = $(this).parent().parent();
          var tabholder_items = tabholder.children('li');
          var code = tab[0].dataset.code;

          if ($(window).width() > 767) {
            if (!tab.hasClass('active')) {
              activeTab = tab;
              tabholder_items.removeClass('active');
              tab.addClass('active');

              component_items.each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          }
        });
      },
    },

    page_template_template_cardiology_care_pathway_solutions: {
      init: function () {
        // JavaScript to be fired on all pages
        $('.content-list-component.mobile-accordion .tabs-list .title').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.content-list-component.mobile-accordion .tabs-list .title').removeClass('open');
            $('.content-list-component.mobile-accordion .tabs-list .title').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var component = $(this).parent().closest('.content-list-component');
          var component_items = component.find('div.item');
          var tabholder = $(this).parent().parent();
          var tabholder_items = tabholder.children('li');
          var code = tab[0].dataset.code;

          if ($(window).width() > 767) {
            if (!tab.hasClass('active')) {
              activeTab = tab;
              tabholder_items.removeClass('active');
              tab.addClass('active');

              component_items.each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          }
        });
      },
    },

    page_template_template_xm_ruo_page: {
      init: function () {
        // JavaScript to be fired on all pages

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.content-list-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.content-list-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.content-list-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_xm_mrd_page: {
      init: function () {
        // JavaScript to be fired on all pages

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.content-list-component .tabs-list li.active');
        });

        $('.content-list-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 681) {
            console.log('now');
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.content-list-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.content-list-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });

              $('.content-list-component .code-pagination a').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.content-list-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_tempus_tech: {
      init: function () {
        // JavaScript to be fired on all pages
        $('.tempus-tech-acc-opener').on('click', function (e) {
          e.preventDefault();
          // $(this).scrollIntoView();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.tempus-tech-acc-opener').removeClass('open');
            $('.tempus-tech-acc-opener').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();

            var headerOffset = $('#header').height() + 1;
            if ($('.show-banner').length) {
              var bannerOffset = $('.announcement-banner').height();
            } else {
              var bannerOffset = 0;
            }
            var totalOffset = headerOffset + bannerOffset;
            $([document.documentElement, document.body]).animate({
              scrollTop: $('.tempus-tech-acc-opener.open').offset().top - totalOffset,
            }, 300);

          }

          return false;
        });

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.tempus-tech-component .tabs-list li.active');
        });

        $('.tempus-tech-component .tabs-list a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 991) {
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.tempus-tech-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.tempus-tech-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.tempus-tech-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });
      },
    },

    page_template_template_tempus_one_v2: {
      init: function () {
        $(window).on('scroll', function () {
          $('.scenarios-slider').each(function () {
            const steps = Number($(this).attr('data-steps'));
            const containerRect = this.getBoundingClientRect();
            const slidesRect = $(this).find('.slides-wrapper')[0].getBoundingClientRect();
            const progress = Math.min((slidesRect.y - containerRect.y) / (containerRect.height - slidesRect.height), 1);
            const stepIndexBase1 = 1 + Math.round(progress * (steps - 1));
            $(this).
              find('.text-slide, .image-slide').
              removeClass('active').
              filter('.step-' + stepIndexBase1).
              addClass('active');
            $(this).
              find('.to-pagination-list .to-pagination-bullet').
              removeClass('active').
              filter(':eq(' + (stepIndexBase1 - 1) + ')').
              addClass('active');
          });
        }).trigger('scroll');

        $('.lightbox').each(function () {
          $(this).find('video').get(0).pause();
        });

        $('.open-video').on('click', function (event) {
          event.preventDefault();
          var team = $(this).attr('href');

          $(team).fadeIn(0);
          $('body').addClass('open-lightbox');

          $('.lightbox').find('video').get(0).pause();

          if ($(team).find('video').length) {
            $(team).find('video').get(0).play();
          }
        });

        $('.lightbox .close-medium').on('click', function () {
          $('body').removeClass('open-lightbox');
          $('.lightbox').fadeOut(0);
          $('.page-overlay').hide();
          var vid = jQuery(this).closest('.lightbox').find('iframe[src*="youtube"]');
          if (vid.length > 0) {
            var src = vid.attr('src');
            vid.attr('src', '');
            vid.attr('src', src);
          }

          $(this).closest('.lightbox').find('video').get(0).pause();

        });
      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_tempus_hub_page: {
      init: function () {

      },

      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
    },

    page_template_template_tempus_one_ls: {
      init: function () {

        $(window).on('scroll', function () {
          $('.scenarios-slider').each(function () {
            const steps = Number($(this).attr('data-steps'));
            const containerRect = this.getBoundingClientRect();
            const slidesRect = $(this).find('.slides-wrapper')[0].getBoundingClientRect();
            const progress = Math.min((slidesRect.y - containerRect.y) / (containerRect.height - slidesRect.height), 1);
            const stepIndexBase1 = 1 + Math.round(progress * (steps - 1));
            $(this).
              find('.text-slide, .image-slide').
              removeClass('active').
              filter('.step-' + stepIndexBase1).
              addClass('active');
            $(this).
              find('.pagination-list .pagination-bullet').
              removeClass('active').
              filter(':eq(' + (stepIndexBase1 - 1) + ')').
              addClass('active');
          });
        }).trigger('scroll');
        
        $('.ai-tech-acc-opener').on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('open')) {
            $(this).next().slideUp();
            $(this).toggleClass('open');
          } else {
            $('.ai-tech-acc-opener').removeClass('open');
            $('.ai-tech-acc-opener').next().slideUp();
            $(this).toggleClass('open');
            $(this).next().slideDown();
          }

          return false;
        });

      },
      finalize: function () {

        //Tab Click
        var tabIndex = 0;
        var activeTab;

        $(window).on('load', function () {
          activeTab = $('.ai-tech-component .tabs-list li.active');
        });

        $('.ai-tech-component .tabs-list ul a').on('click', function (e) {
          e.preventDefault();
          var tab = $(this).parent();
          var code = tab[0].dataset.code;

          if ($(window).width() > 991) {
            if (!tab.hasClass('active')) {
              activeTab = tab;
              $('.ai-tech-component .tabs-list li').removeClass('active');
              tab.addClass('active');

              $('.ai-tech-component .item').each(function () {
                if ($(this)[0].dataset.code === code) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
              });
            }
          } else {
            tab.toggleClass('active');
            $('.ai-tech-component .tabs-list li').each(function () {
              if ($(this).hasClass('active')) {
                $(this).children('.mobile-item').addClass('active');
              } else {
                $(this).children('.mobile-item').removeClass('active');
              }
            });
          }
        });

      },
    },

    page_template_template_tempus_one_providers: {
      init: function () {

        $(window).on('scroll', function () {
          $('.scenarios-slider').each(function () {
            const steps = Number($(this).attr('data-steps'));
            const containerRect = this.getBoundingClientRect();
            const slidesRect = $(this).find('.slides-wrapper')[0].getBoundingClientRect();
            const progress = Math.min((slidesRect.y - containerRect.y) / (containerRect.height - slidesRect.height), 1);
            const stepIndexBase1 = 1 + Math.round(progress * (steps - 1));
            $(this).
              find('.text-slide, .image-slide').
              removeClass('active').
              filter('.step-' + stepIndexBase1).
              addClass('active');
            $(this).
              find('.pagination-list .pagination-bullet').
              removeClass('active').
              filter(':eq(' + (stepIndexBase1 - 1) + ')').
              addClass('active');
          });
        }).trigger('scroll');

      },
      finalize: function () {
        

      },
    },

  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(window.jQuery, window.Clique); // Fully reference jQuery after this point.
